(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55131],{

/***/ 21737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Alert_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(93680);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 12 modules
var styled = __webpack_require__(53342);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/alertClasses.js


function getAlertUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAlert', slot);
}
const alertClasses = (0,generateUtilityClasses/* default */.Z)('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
/* harmony default export */ var Alert_alertClasses = (alertClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js + 2 modules
var createSvgIcon = __webpack_require__(88169);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/SuccessOutlined.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var SuccessOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ReportProblemOutlined.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var ReportProblemOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ErrorOutline.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var ErrorOutline = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/InfoOutlined.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var InfoOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/Close.js



/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */

/* harmony default export */ var Close = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/Alert.js


const _excluded = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"];


















const useUtilityClasses = ownerState => {
  const {
    variant,
    color,
    severity,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${variant}${(0,capitalize/* default */.Z)(color || severity)}`, `${variant}`],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return (0,composeClasses/* default */.Z)(slots, getAlertUtilityClass, classes);
};
const AlertRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0,capitalize/* default */.Z)(ownerState.color || ownerState.severity)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const getColor = theme.palette.mode === 'light' ? colorManipulator/* darken */._j : colorManipulator/* lighten */.$n;
  const getBackgroundColor = theme.palette.mode === 'light' ? colorManipulator/* lighten */.$n : colorManipulator/* darken */._j;
  const color = ownerState.color || ownerState.severity;
  return (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px'
  }, color && ownerState.variant === 'standard' && {
    color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
    backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
    [`& .${Alert_alertClasses.icon}`]: theme.vars ? {
      color: theme.vars.palette.Alert[`${color}IconColor`]
    } : {
      color: theme.palette[color].main
    }
  }, color && ownerState.variant === 'outlined' && {
    color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
    border: `1px solid ${(theme.vars || theme).palette[color].light}`,
    [`& .${Alert_alertClasses.icon}`]: theme.vars ? {
      color: theme.vars.palette.Alert[`${color}IconColor`]
    } : {
      color: theme.palette[color].main
    }
  }, color && ownerState.variant === 'filled' && (0,esm_extends/* default */.Z)({
    fontWeight: theme.typography.fontWeightMedium
  }, theme.vars ? {
    color: theme.vars.palette.Alert[`${color}FilledColor`],
    backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
  } : {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
    color: theme.palette.getContrastText(theme.palette[color].main)
  }));
});
const AlertIcon = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
const AlertMessage = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0',
  minWidth: 0,
  overflow: 'auto'
});
const AlertAction = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
const defaultIconMapping = {
  success: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessOutlined, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/(0,jsx_runtime.jsx)(ReportProblemOutlined, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorOutline, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined, {
    fontSize: "inherit"
  })
};
const Alert = /*#__PURE__*/react.forwardRef(function Alert(inProps, ref) {
  var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAlert'
  });
  const {
      action,
      children,
      className,
      closeText = 'Close',
      color,
      components = {},
      componentsProps = {},
      icon,
      iconMapping = defaultIconMapping,
      onClose,
      role = 'alert',
      severity = 'success',
      slotProps = {},
      slots = {},
      variant = 'standard'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    severity,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : IconButton/* default */.Z;
  const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : Close;
  const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
  const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AlertRoot, (0,esm_extends/* default */.Z)({
    role: role,
    elevation: 0,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AlertCloseButton, (0,esm_extends/* default */.Z)({
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
      }, closeButtonProps, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AlertCloseIcon, (0,esm_extends/* default */.Z)({
          fontSize: "small"
        }, closeIconProps))
      }))
    }) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Alert_Alert = (Alert);

/***/ }),

/***/ 91325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[product]",
      function () {
        return __webpack_require__(49509);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36456);
/* harmony import */ var _redux_services_taxons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50173);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16502);








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var mapStateToProp = function(state) {
    return {
        taxons: state.taxons.items
    };
};
var HreflangLinks = function(param) {
    var locales = param.locales, taxons = param.taxons;
    var ref3;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var asPath = router.asPath, defaultLocale = router.defaultLocale, locale = router.locale;
    var category = router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.slug;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Map()), allTaxons = ref1[0], setAllTaxons = ref1[1];
    var uniqueLocales = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return Array.from(new Set(locales.map(function(loc) {
            return loc.split('-')[0];
        }))).map(function(uniqueLoc) {
            return locales.find(function(loc) {
                return loc.startsWith(uniqueLoc);
            });
        }).filter(function(loc) {
            return !!loc;
        });
    }, [
        locales
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), currentOrigin = ref2[0], setCurrentOrigin = ref2[1];
    var defaultLang = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return uniqueLocales.find(function(lang) {
            return lang.includes(defaultLocale);
        });
    }, [
        defaultLocale,
        uniqueLocales
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            setCurrentOrigin(window.location.origin);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref4;
        if (!router.isReady || taxons.length === 0 || locales.length === 1 || !category) return;
        setAllTaxons(new Map([
            [
                locale,
                ((ref4 = taxons[0]) === null || ref4 === void 0 ? void 0 : ref4.children) || []
            ]
        ]));
        var fetchTaxons = function() {
            var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(localesToFetch) {
                var ref, fetchedTaxons;
                return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (0,_redux_services_taxons__WEBPACK_IMPORTED_MODULE_6__/* .getLocalesTaxons */ .OD)(localesToFetch);
                        case 3:
                            fetchedTaxons = _ctx.sent;
                            setAllTaxons(new Map(_toConsumableArray(Object.entries(fetchedTaxons)).concat([
                                [
                                    locale,
                                    ((ref = taxons[0]) === null || ref === void 0 ? void 0 : ref.children) || []
                                ], 
                            ])));
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchTaxons(localesToFetch) {
                return _ref.apply(this, arguments);
            };
        }();
        fetchTaxons(uniqueLocales.map(function(loc) {
            return loc.split('-')[0];
        }).filter(function(loc) {
            return loc !== locale;
        }));
    }, [
        locale,
        locales,
        taxons,
        router.isReady,
        uniqueLocales
    ]);
    var hreflangLinks = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var links = [];
        var slugs = category ? Array.isArray(category) ? _toConsumableArray(category) : [
            category
        ] : [];
        locales.forEach(function(loc) {
            var isDefault = loc === defaultLang;
            var currentLocale = loc.split('-')[0];
            if (isDefault) {
                var href = "".concat(currentOrigin).concat(asPath);
                if (currentLocale !== locale && (slugs === null || slugs === void 0 ? void 0 : slugs.length) > 0 && allTaxons.size > 1) {
                    href = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__/* .translateUrlSlugs */ .fg)(href, _toConsumableArray(slugs), allTaxons.get(locale), allTaxons.get(currentLocale));
                }
                links.push({
                    href: href.endsWith('/') ? href.slice(0, -1) : href,
                    hreflang: 'x-default'
                });
            }
            var href1 = "".concat(currentOrigin).concat(isDefault ? '' : "/".concat(currentLocale)).concat(asPath);
            if (currentLocale !== locale && (slugs === null || slugs === void 0 ? void 0 : slugs.length) > 0 && allTaxons.size > 1) {
                href1 = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__/* .translateUrlSlugs */ .fg)(href1, _toConsumableArray(slugs), allTaxons.get(locale), allTaxons.get(currentLocale));
            }
            links.push({
                href: href1.endsWith('/') ? href1.slice(0, -1) : href1,
                hreflang: loc
            });
        });
        return links;
    }, [
        locales,
        defaultLang,
        currentOrigin,
        asPath,
        locale,
        taxons,
        allTaxons
    ]);
    if (!currentOrigin || locales.length === 0 || !defaultLang) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
        children: hreflangLinks.map(function(link, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                rel: "alternate",
                href: link.href,
                hrefLang: link.hreflang
            }, index);
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProp)(HreflangLinks));


/***/ }),

/***/ 49509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _product_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/node_modules/react-is/index.js
var react_is = __webpack_require__(65122);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(85160);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/BreadcrumbCollapsed.js









var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes"]);

  return /*#__PURE__*/react.createElement(ButtonBase/* default */.Z, (0,esm_extends/* default */.Z)({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/react.createElement(MoreHoriz, {
    className: classes.icon
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js










var Breadcrumbs_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/react.createElement("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = react.useState(false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}

      return allItems;
    }

    return [].concat((0,toConsumableArray/* default */.Z)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/react.createElement(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], (0,toConsumableArray/* default */.Z)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = react.Children.toArray(children).filter(function (child) {
    if (false) {}

    return /*#__PURE__*/react.isValidElement(child);
  }).map(function (child, index) {
    return /*#__PURE__*/react.createElement("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/react.createElement(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other), /*#__PURE__*/react.createElement("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = ((0,withStyles/* default */.Z)(Breadcrumbs_styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./components/Hero/HeroSection.tsx
var HeroSection = __webpack_require__(87170);
// EXTERNAL MODULE: ./components/DateRangeForm/DateRangeForm.tsx + 1 modules
var DateRangeForm = __webpack_require__(4998);
// EXTERNAL MODULE: ./components/Shop/Shop.style.tsx
var Shop_style = __webpack_require__(45889);
// EXTERNAL MODULE: ./redux/actions/products.ts
var actions_products = __webpack_require__(86730);
// EXTERNAL MODULE: ./typings/base.ts
var base = __webpack_require__(88039);
// EXTERNAL MODULE: ./components/Sizes/TakeBackSize.tsx + 1 modules
var TakeBackSize = __webpack_require__(95189);
// EXTERNAL MODULE: ./node_modules/react-glider/dist/index.js
var dist = __webpack_require__(76142);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Shop/ProductCard.tsx + 4 modules
var ProductCard = __webpack_require__(18496);
// EXTERNAL MODULE: ./utils/addToCart.tsx
var addToCart = __webpack_require__(63226);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./components/InStore/ChangeStoreModal.tsx
var ChangeStoreModal = __webpack_require__(63052);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./components/Shop/BottomMenuLinks.tsx
var BottomMenuLinks = __webpack_require__(7395);
// EXTERNAL MODULE: ./components/Shop/CommonInformations.tsx + 1 modules
var CommonInformations = __webpack_require__(55407);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(57821);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
;// CONCATENATED MODULE: ./components/Shop/TakeBackAndRentTab.tsx






var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        tabContainer: {
            margin: theme.spacing(2, 0, 2)
        },
        rentAndSecondHandTabs: {},
        rentAndSecondHandTab: {
            minWidth: 0
        }
    });
});
var MainTooltip = (0,withStyles/* default */.Z)(function(theme) {
    return {
        tooltip: {
            textAlign: 'center',
            fontSize: 11,
            padding: theme.spacing(1),
            lineHeight: 1,
            '&:hover, &:focus': {
                cursor: 'default'
            },
            marginBottom: -theme.spacing(1)
        }
    };
})(Tooltip/* default */.ZP);
var TakeBackAndRentTab = function(param) {
    var selectedTakeBackOrRental = param.selectedTakeBackOrRental, handleTakeBackAndRental = param.handleTakeBackAndRental, takeback = param.takeback, t = param.t, typeInCart = param.typeInCart;
    var ref, ref1, ref2, ref3;
    var tabClasses = useStyles();
    var ref4 = (0,react.useState)(false), showTooltip = ref4[0], setShowTooltip = ref4[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: tabClasses.tabContainer,
        onMouseEnter: function() {
            return setShowTooltip(true);
        },
        onMouseLeave: function() {
            return setShowTooltip(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
            value: selectedTakeBackOrRental,
            onChange: handleTakeBackAndRental,
            scrollButtons: 'auto',
            className: tabClasses.rentAndSecondHandTabs,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTooltip, {
                    placement: 'top',
                    open: showTooltip && typeInCart === 'SECOND_HAND',
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.prevent_adding_differents_types_to_cart,
                        defaultText: t('texts:takeBack:prevent_adding_differents_types_to_cart')
                    }),
                    arrow: true,
                    enterDelay: 2000,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: takeback === null || takeback === void 0 ? void 0 : (ref1 = takeback.data) === null || ref1 === void 0 ? void 0 : ref1.tab_label_rental,
                            defaultText: t('texts:takeBack:tab_label_rental')
                        }),
                        className: tabClasses.rentAndSecondHandTab,
                        value: 0,
                        disabled: typeInCart === 'SECOND_HAND'
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTooltip, {
                    placement: 'top',
                    open: showTooltip && typeInCart === 'RENTAL',
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: takeback === null || takeback === void 0 ? void 0 : (ref2 = takeback.data) === null || ref2 === void 0 ? void 0 : ref2.prevent_adding_differents_types_to_cart,
                        defaultText: t('texts:takeBack:prevent_adding_differents_types_to_cart')
                    }),
                    arrow: true,
                    enterDelay: 2000,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.tab_label_secondhand,
                            defaultText: t('texts:takeBack:tab_label_secondhand')
                        }),
                        value: 1,
                        disabled: typeInCart === 'RENTAL'
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Shop_TakeBackAndRentTab = (TakeBackAndRentTab);

// EXTERNAL MODULE: ./components/InStore/InStoreSoldOut.tsx
var InStoreSoldOut = __webpack_require__(67866);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button_Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/Shop/QuantitySelector.tsx
var QuantitySelector = __webpack_require__(83230);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/fr/index.js + 5 modules
var fr = __webpack_require__(75830);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(70879);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/es/index.js + 5 modules
var locale_es = __webpack_require__(63345);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/nl/index.js + 5 modules
var nl = __webpack_require__(94638);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./components/Shop/AvailabilityChecker.tsx









//Add locale translations of date picker






(0,react_datepicker_min.registerLocale)('fr', fr/* default */.Z);
(0,react_datepicker_min.registerLocale)('de', de/* default */.Z);
(0,react_datepicker_min.registerLocale)('es', locale_es/* default */.Z);
(0,react_datepicker_min.registerLocale)('nl', nl/* default */.Z);
var AvailabilityChecker_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        modal: {
            '& .MuiDialog-paper': {
                borderRadius: 0,
                padding: 0,
                background: 'none',
                boxShadow: 'none'
            },
            '& .react-datepicker': {
                justifyContent: 'center',
                minHeight: 325,
                '&__navigation': {
                    borderRadius: 0,
                    '&--next': {
                        '&--disabled': {
                            opacity: 0
                        }
                    }
                },
                '&__day': {
                    pointerEvents: 'none',
                    userSelect: 'none',
                    verticalAlign: 'top',
                    '&--outside-month': {
                    },
                    '&--excluded': {
                        color: theme.extraColors.greyText,
                        textDecoration: 'line-through'
                    }
                }
            }
        },
        text: {
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            '&:before': {
                content: '" "',
                display: 'inline-block',
                width: '0.5em',
                height: '0.5em',
                borderRadius: '50%',
                marginRight: '1ch',
                verticalAlign: 'middle',
                background: theme.palette.error.main
            }
        },
        link: {
            cursor: 'pointer',
            padding: 0,
            textDecoration: 'underline',
            color: theme.palette.primary.main,
            '&:hover, &:focus': {
                textDecoration: 'none'
            }
        },
        datePicker: {},
        content: {
            padding: theme.spacing(0, 0, 1),
            backgroundColor: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1]
        },
        head: {
            padding: theme.spacing(2)
        },
        headTitle: {},
        headDesc: {
            '& p': {
                margin: 0
            }
        },
        close: {
            display: 'flex',
            justifyContent: 'flex-end',
            color: theme.palette.common.white,
            padding: theme.spacing(1, 0)
        },
        closeBtn: {
            padding: 0,
            color: theme.palette.common.white,
            minWidth: theme.spacing(4),
            '&:hover, &:focus': {
                background: 'none'
            }
        }
    });
});
var AvailabilityChecker = function(param) {
    var unvailabilities = param.unvailabilities, endLeasingDate = param.endLeasingDate, t = param.t, texts = param.texts, cart = param.cart;
    var ref;
    var customCSSRoot = 'availability-checker';
    var classes = AvailabilityChecker_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)([]), excludedDates = ref2[0], setExcludedDates = ref2[1];
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var router = (0,next_router.useRouter)();
    var currentLocale = (router === null || router === void 0 ? void 0 : router.locale) ? router.locale : 'fr';
    var startDate1 = cart && cart.item && cart.item.startLeasingDate !== undefined && dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').toDate();
    var maxEndDate = dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.startLeasingDate, constants/* SyliusDateFormat */.cl).add(endLeasingDate - 1, 'day');
    var handleClose = function() {
        setOpen(false);
    };
    var handleAvailabilityCheck = function() {
        setOpen(true);
    };
    (0,react.useEffect)(function() {
        var excludedDatesArr = [];
        // First check if they are unvailabilities
        if (unvailabilities.length > 0) {
            // if yes, iterate on each object and add it to the excluded dates array
            unvailabilities.forEach(function(unvailability) {
                var startDate = dayjs_min_default()(unvailability.startDate, constants/* RMSDateFormat */.oy);
                // if end date is not defined (with empty string), we use end date defined in redux parameter.
                // it will show unavailibity until the end of leasing
                var endDate = unvailability.endDate === '' ? dayjs_min_default()(maxEndDate, constants/* SyliusDateFormat */.cl) : dayjs_min_default()(unvailability.endDate, constants/* RMSDateFormat */.oy);
                for(var date = startDate; date <= endDate; date = date.add(1, 'day')){
                    excludedDatesArr.push(date.toDate());
                }
                setExcludedDates(excludedDatesArr);
            });
        }
    }, [
        unvailabilities
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "caption",
                component: 'div',
                className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__text"), classes.text),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        defaultText: t('texts:single_product:availability_checker:text'),
                        data: texts === null || texts === void 0 ? void 0 : texts.availability_checker_text
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "button",
                        className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__link"), classes.link),
                        onClick: function() {
                            return handleAvailabilityCheck();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            defaultText: t('texts:single_product:availability_checker:link'),
                            data: texts === null || texts === void 0 ? void 0 : texts.availability_checker_link
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                open: open,
                maxWidth: 'lg',
                className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__modal"), classes.modal),
                scroll: 'paper',
                disableBackdropClick: true,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__modal-close"), classes.close),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                            disableRipple: true,
                            onClick: handleClose,
                            className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__modal-close__btn"), classes.closeBtn),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "srOnly",
                                    children: t('texts:single_product:availability_checker:modal_close')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__modal-content"), classes.content),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__modal-head"), classes.head),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h4",
                                        component: 'h2',
                                        className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__modal-head__title"), classes.headTitle),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            defaultText: t('texts:single_product:availability_checker:modal_title'),
                                            data: texts === null || texts === void 0 ? void 0 : texts.availability_checker_modal_title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        component: 'div',
                                        className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__modal-head__desc"), classes.headDesc),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            defaultText: t('texts:single_product:availability_checker:modal_description'),
                                            data: texts === null || texts === void 0 ? void 0 : texts.availability_checker_modal_description
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                locale: currentLocale,
                                onChange: function() {
                                    return startDate1;
                                },
                                openToDate: startDate1,
                                minDate: startDate1,
                                maxDate: dayjs_min_default()(maxEndDate, constants/* SyliusDateFormat */.cl).toDate(),
                                monthsShown: isMobile ? 1 : 2,
                                inline: true,
                                excludeDates: excludedDates,
                                className: (0,clsx_m/* default */.Z)("".concat(customCSSRoot, "__datepicker"), classes.datePicker),
                                showDisabledMonthNavigation: true
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Shop_AvailabilityChecker = (AvailabilityChecker);

// EXTERNAL MODULE: ./utils/productVariantDisplay.ts
var productVariantDisplay = __webpack_require__(16758);
// EXTERNAL MODULE: ./components/BackInStockAlert/BackInStockAlert.tsx
var BackInStockAlert = __webpack_require__(99871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
;// CONCATENATED MODULE: ./components/Products/ProductSkiForm.tsx












function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ProductSkiForm_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        selectLabel: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            fontSize: 11,
            paddingLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5)
        },
        select: {
            display: 'block',
            padding: theme.spacing(1, 0.5),
            fontFamily: theme.typography.fontFamily,
            width: '100%',
            fontSize: 14,
            borderRadius: theme.shape.borderRadius,
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight
        },
        checkboxText: {
            fontStyle: 'italic'
        },
        buttonSki: {
            float: 'right'
        },
        skiForm: {
            '& label': {
                paddingLeft: '5px'
            }
        }
    });
});
var ProductSkiForm = function(param) {
    var skiText = param.skiText, product = param.product, variantCode = param.variantCode;
    var ref22, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var classes = ProductSkiForm_useStyles();
    var addProductToCart = (0,useCart/* useCart */.j)().addProductToCart;
    var ref14 = (0,react.useState)(''), weight = ref14[0], setWeight = ref14[1];
    var ref15 = (0,react.useState)(''), size = ref15[0], setSize = ref15[1];
    var ref16 = (0,react.useState)('inf\xe9rieur \xe0 10 ans'), age = ref16[0], setAge = ref16[1];
    var array = [];
    skiText === null || skiText === void 0 ? void 0 : (ref22 = skiText.data) === null || ref22 === void 0 ? void 0 : (ref1 = ref22.levels) === null || ref1 === void 0 ? void 0 : ref1.map(function(level) {
        var ref, ref21;
        array.push({
            level: (ref = level === null || level === void 0 ? void 0 : level.level[0]) === null || ref === void 0 ? void 0 : ref.text,
            label: (ref21 = level === null || level === void 0 ? void 0 : level.level[0]) === null || ref21 === void 0 ? void 0 : ref21.text
        });
    });
    var options = typeof (skiText === null || skiText === void 0 ? void 0 : (ref2 = skiText.data) === null || ref2 === void 0 ? void 0 : ref2.levels) === 'undefined' ? [
        {
            level: 'D\xe9butant',
            label: 'D\xe9butant'
        },
        {
            level: 'Interm\xe9diaire',
            label: 'Interm\xe9diaire'
        },
        {
            level: 'Confirm\xe9',
            label: 'Confirm\xe9'
        }, 
    ] : array;
    var ageOptions = [
        {
            age: 'inf\xe9rieur \xe0 10 ans',
            label: 'inf\xe9rieur \xe0 10 ans'
        },
        {
            age: '11 ans \xe0 49 ans',
            label: '11 ans \xe0 49 ans'
        },
        {
            age: 'sup\xe9rieur \xe0 50 ans',
            label: 'sup\xe9rieur \xe0 50 ans'
        }, 
    ];
    var ref17 = (0,react.useState)((ref3 = options[0]) === null || ref3 === void 0 ? void 0 : ref3.level), level1 = ref17[0], setLevel = ref17[1];
    var ref18 = (0,react.useState)(''), firstname = ref18[0], setFirstname = ref18[1];
    var ref19 = (0,react.useState)(false), sizeCheckbox = ref19[0], setSizeCheckbox = ref19[1];
    var ref20 = (0,react.useState)([]), skiArray = ref20[0], setSkiArray = ref20[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var handleSizeBox = function() {
        setSizeCheckbox(!sizeCheckbox);
    };
    var handleLevel = function(event) {
        setLevel(event.target.value);
    };
    var handleAge = function(event) {
        setAge(event.target.value);
    };
    var handleAddProduct = function() {
        var ref, ref23, ref24, ref25;
        var currentArray = _toConsumableArray(skiArray);
        currentArray.push({
            size: parseInt(size),
            weight: parseInt(weight),
            level: level1,
            firstname: firstname,
            age: age
        });
        var price = (0,utils/* numberToPrice */.e8)((ref23 = (ref = product.item) === null || ref === void 0 ? void 0 : ref.variants[variantCode]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.price) === null || ref24 === void 0 ? void 0 : ref24.current);
        addProductToCart({
            productCode: product.code,
            quantity: 1,
            variantCode: variantCode,
            skis: currentArray
        });
        trackEvent({
            category: 'Add to Cart for tryout',
            action: "".concat(product === null || product === void 0 ? void 0 : (ref25 = product.item) === null || ref25 === void 0 ? void 0 : ref25.name),
            name: "".concat(next_router["default"].pathname),
            value: price
        });
        setSkiArray([]);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        container: true,
        spacing: 1,
        className: classes.skiForm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: skiText === null || skiText === void 0 ? void 0 : (ref4 = skiText.data) === null || ref4 === void 0 ? void 0 : ref4.try_out,
                        defaultText: t('texts:skiText:title')
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: skiText === null || skiText === void 0 ? void 0 : (ref5 = skiText.data) === null || ref5 === void 0 ? void 0 : ref5.weight_label,
                        defaultText: t('texts:skiText:weight_label')
                    }),
                    type: "number",
                    name: "weight",
                    min: 0,
                    placeholder: '70',
                    value: weight,
                    required: true,
                    onChange: setWeight
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: skiText === null || skiText === void 0 ? void 0 : (ref6 = skiText.data) === null || ref6 === void 0 ? void 0 : ref6.size_label,
                        defaultText: t('texts:skiText:size_label')
                    }),
                    type: "number",
                    name: "weight",
                    placeholder: '172',
                    min: 0,
                    value: size,
                    required: true,
                    onChange: setSize
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: skiText === null || skiText === void 0 ? void 0 : (ref7 = skiText.data) === null || ref7 === void 0 ? void 0 : ref7.firstname,
                        defaultText: t('texts:skiText:firstname')
                    }),
                    type: "text",
                    name: "fistname",
                    placeholder: 'John',
                    value: firstname,
                    required: true,
                    onChange: setFirstname
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                xs: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (0,clsx_m/* default */.Z)(classes.selectLabel, 'label'),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: skiText === null || skiText === void 0 ? void 0 : (ref8 = skiText.data) === null || ref8 === void 0 ? void 0 : ref8.level_label,
                            defaultText: t('texts:skiText:level_label')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                        value: level1,
                        onChange: handleLevel,
                        required: true,
                        defaultValue: (ref9 = options[0]) === null || ref9 === void 0 ? void 0 : ref9.value,
                        name: "select",
                        className: (0,clsx_m/* default */.Z)(classes.select, 'select'),
                        children: options === null || options === void 0 ? void 0 : options.map(function(option, index) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: option === null || option === void 0 ? void 0 : option.level,
                                children: option === null || option === void 0 ? void 0 : option.label
                            }, index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                xs: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (0,clsx_m/* default */.Z)(classes.selectLabel, 'label'),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: skiText === null || skiText === void 0 ? void 0 : (ref10 = skiText.data) === null || ref10 === void 0 ? void 0 : ref10.age_label,
                            defaultText: t('texts:skiText:age_label')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                        value: age,
                        onChange: handleAge,
                        required: true,
                        defaultValue: (ref11 = ageOptions[0]) === null || ref11 === void 0 ? void 0 : ref11.age,
                        name: "select",
                        className: (0,clsx_m/* default */.Z)(classes.select, 'select'),
                        children: ageOptions === null || ageOptions === void 0 ? void 0 : ageOptions.map(function(option, index) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: option === null || option === void 0 ? void 0 : option.age,
                                children: option === null || option === void 0 ? void 0 : option.label
                            }, index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: sizeCheckbox,
                        onChange: handleSizeBox,
                        name: "checkedA"
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body2',
                        component: 'div',
                        className: classes.checkboxText,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: skiText === null || skiText === void 0 ? void 0 : (ref12 = skiText.data) === null || ref12 === void 0 ? void 0 : ref12.shoes_size_commitment,
                            defaultText: t('texts:skiText:shoes_size_commitment')
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)(classes.buttonSki, 'product__btn-addtocart'),
                    variant: "contained",
                    color: "primary",
                    disabled: firstname === '' || sizeCheckbox === false || weight === '' || level1 === '' || age === '' || size === '',
                    onClick: function() {
                        return handleAddProduct();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: skiText === null || skiText === void 0 ? void 0 : (ref13 = skiText.data) === null || ref13 === void 0 ? void 0 : ref13.button_text,
                        defaultText: t('texts:skiText:button_text')
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Products_ProductSkiForm = (ProductSkiForm);

// EXTERNAL MODULE: ./components/Products/AboveProductDescriptionText.tsx
var AboveProductDescriptionText = __webpack_require__(75060);
;// CONCATENATED MODULE: ./components/Sizes/Size.tsx
/* provided dependency */ var process = __webpack_require__(34155);


/* eslint-disable @typescript-eslint/no-unused-expressions */ 

















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Size_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
        },
        sizes: {
            display: 'flex',
            justifyContent: 'flex-start',
            marginTop: theme.spacing(1)
        },
        sizes__label: {
            paddingRight: theme.spacing(1)
        },
        sizes__list: {
            padding: theme.spacing(0.25, 0.25, 0.25, 0),
            borderRadius: theme.spacing(1),
            marginBottom: theme.spacing(1),
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start'
        },
        aboveProductDescriptionText: {
            marginTop: theme.spacing(1)
        },
        addButton: _defineProperty({
            display: 'flex',
            justifyContent: 'flex-end'
        }, theme.breakpoints.down('sm'), {
            justifyContent: 'space-between',
            marginTop: theme.spacing(1)
        }),
        button: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
            width: '100%'
        },
        sizeButton: _defineProperty({
            height: theme.spacing(4),
            padding: theme.spacing(1, 2),
            margin: theme.spacing(0.5, 0.5, 0.5, 0),
            minWidth: 45,
            backgroundColor: theme.extraColors.greyLight,
            '&:hover': {
                backgroundColor: theme.palette.common.black,
                color: theme.palette.common.white
            },
            '&.sold-out': {
                opacity: 0.5,
                color: theme.palette.error.main
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        withoutStock: {
            opacity: 0.5,
            color: theme.palette.error.main
        },
        selected: _defineProperty({
            height: theme.spacing(4),
            padding: theme.spacing(1, 2),
            margin: theme.spacing(0.5, 0.5, 0.5, 0),
            minWidth: 45,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
            '&:hover': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.common.black
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        quantSelector: {
            marginRight: theme.spacing(2)
        },
        quantityChip: {
            position: 'absolute',
            top: -5,
            right: -5,
            minWidth: 20,
            height: 20,
            lineHeight: '20px',
            borderRadius: 20,
            padding: '0px 6px',
            fontSize: 13,
            border: "1px solid ".concat(theme.palette.common.white),
            color: theme.palette.common.white,
            backgroundColor: theme.palette.secondary.main
        },
        quantityChipSelected: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white
        },
        tryOut: {
            marginBottom: theme.spacing(1.5)
        },
        tryOutButton: {
            marginTop: theme.spacing(1.5)
        },
        fullWidth: {
            width: '100%'
        },
        availabilityChecker: {}
    });
});
var Size_MainTooltip = (0,withStyles/* default */.Z)(function(theme) {
    return {
        tooltip: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            fontSize: 12,
            textAlign: 'center',
            padding: theme.spacing(1),
            width: '100%'
        },
        arrow: {
            color: theme.palette.secondary.main
        }
    };
})(Tooltip/* default */.ZP);
var mapStateToProps = function(state) {
    return {
        parameters: state.parameters,
        stores: state.stores,
        sizesNamePositionMap: state.taxons.sizesNamePositionMap
    };
};
var mapDispatchToProps = {
    getProductVariantAvailability: actions_products/* getProductVariantAvailability */.eI
};
var Size = function(param) {
    var products = param.products, onQuantityChange = param.onQuantityChange, cart = param.cart, text = param.text, t = param.t, stock = param.stock, settings = param.settings, getProductVariantAvailability1 = param.getProductVariantAvailability, parameters = param.parameters, stores = param.stores, isSki = param.isSki, skiText = param.skiText, sizesNamePositionMap = param.sizesNamePositionMap;
    var ref41, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var isAvailabilityChecker = text === null || text === void 0 ? void 0 : (ref41 = text.data) === null || ref41 === void 0 ? void 0 : ref41.availability_checker;
    var classes = Size_useStyles();
    var asPath = (0,next_router.useRouter)().asPath;
    var ref26 = (0,react.useState)(''), code1 = ref26[0], setCode = ref26[1];
    var ref27 = (0,react.useState)(''), name1 = ref27[0], setName = ref27[1];
    var ref28 = (0,react.useState)(1), quantity1 = ref28[0], setQuantity = ref28[1];
    var ref29 = (0,react.useState)(null), hasInStock = ref29[0], setHasInStock = ref29[1];
    var ref30 = (0,react.useState)(false), isTryOutAble = ref30[0], setIsTryOutAble = ref30[1];
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var ref31 = (0,react.useState)(false), hasTryOut = ref31[0], setHasTryOut = ref31[1];
    var ref32 = (0,react.useState)(false), showTooltip = ref32[0], setShowTooltip = ref32[1];
    var ref33 = (0,react.useState)(false), showTooltipRent = ref33[0], setShowTooltipRent = ref33[1];
    var ref34 = (0,react.useState)(0), tryOnPrice = ref34[0], setTryOnPrice = ref34[1];
    var ref35 = (0,react.useState)(null), maxItemsInCart = ref35[0], setMaxItemsInCart = ref35[1];
    var ref36 = (0,react.useState)(false), availybilityChecker = ref36[0], setAvailybilityChecker = ref36[1];
    var ref37 = (0,react.useState)([]), unvailabilities = ref37[0], setUnvailabilities = ref37[1];
    var ref38 = (0,react.useState)([]), focusedProduct = ref38[0], setFocusedProduct = ref38[1];
    var ref39 = (0,react.useMemo)(function() {
        var _variantsMap = new Map();
        var _variants = Object.values(products.variants).sort(function(a, b) {
            _variantsMap.set(a.code, a);
            _variantsMap.set(b.code, b);
            var ref;
            var aPosition = (ref = sizesNamePositionMap === null || sizesNamePositionMap === void 0 ? void 0 : sizesNamePositionMap[a.size]) !== null && ref !== void 0 ? ref : a.position;
            var ref40;
            var bPosition = (ref40 = sizesNamePositionMap === null || sizesNamePositionMap === void 0 ? void 0 : sizesNamePositionMap[b.size]) !== null && ref40 !== void 0 ? ref40 : b.position;
            return aPosition - bPosition;
        });
        return [
            _variants,
            _variantsMap
        ];
    }, [
        products,
        sizesNamePositionMap
    ]), variants = ref39[0], variantsMap = ref39[1];
    var baseUrl =  true && window.location.origin ? window.location.origin : '';
    var warehouseId = (stores === null || stores === void 0 ? void 0 : (ref1 = stores.selectedStore) === null || ref1 === void 0 ? void 0 : ref1.warehouseId) ? stores === null || stores === void 0 ? void 0 : (ref2 = stores.selectedStore) === null || ref2 === void 0 ? void 0 : ref2.warehouseId : process.env.CUSTOM_WAREHOUSE ? process.env.CUSTOM_WAREHOUSE : null;
    var currentFullUrl = baseUrl + asPath;
    var selectedVariant = variantsMap.get(code1);
    (0,react.useEffect)(function() {
        if (variants.length > 0) {
            setHasTryOut(variants[0].tryingOnRequired);
            setTryOnPrice(variants[0].tryingOnPrice);
        }
    }, [
        variants
    ]);
    (0,react.useEffect)(function() {
        var ref, ref42, ref43;
        // reset quantity when cart change (ie if a product is delete, it update the quantity)
        // TODO Check how many product are rented and other tryout
        var globalQuantRented = 0;
        var globalQuantTryOut = 0;
        (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.items.length) > 0 && (cart === null || cart === void 0 ? void 0 : (ref42 = cart.item) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.items) === null || ref43 === void 0 ? void 0 : ref43.map(function(item) {
            if (!(item === null || item === void 0 ? void 0 : item.withTryingOn)) {
                globalQuantRented += item.quantity;
            } else {
                globalQuantTryOut += item.quantity;
            }
        }));
        if (globalQuantRented > globalQuantTryOut) {
            setIsTryOutAble(true);
        } else setIsTryOutAble(false);
        setQuantity(cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
            return el.product.variants[0].code === code1;
        }) !== 'undefined' ? cart.item.items.find(function(el) {
            return el.product.variants[0].code === code1;
        }).quantity : 0);
    }, [
        cart.item
    ]);
    var handleChange = function(code, name, tryingOnRequired, tryingOnPrice) {
        var selectedProduct = products === null || products === void 0 ? void 0 : products.variants[code];
        var inStock = (0,utils/* checkStockQuantity */.LY)(stock, selectedProduct);
        setFocusedProduct([
            {
                sku: selectedProduct.sku,
                quantity: inStock
            }, 
        ]);
        setCode(code);
        setName(name);
        setHasTryOut(tryingOnRequired);
        setTryOnPrice(tryingOnPrice);
        setQuantity(cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
            return el.product.variants[0].code === code;
        }) !== 'undefined' ? cart.item.items.find(function(el) {
            return el.product.variants[0].code === code;
        }).quantity : 0);
        setMaxItemsInCart(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.maxStock);
        setHasInStock(inStock);
        trackEvent({
            category: 'Products',
            action: "Size selected",
            name: "".concat(name)
        });
        if (isAvailabilityChecker) {
            if (inStock === 0) {
                setAvailybilityChecker(true);
                setHasInStock(inStock);
                var checkProductVariantStock = function() {
                    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                        var response;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return getProductVariantAvailability1(products === null || products === void 0 ? void 0 : products.variants[code].sku);
                                case 2:
                                    response = _ctx.sent;
                                    if (response.type === 'GET_STOCK_AVAILABILITY_SUCCESS') {
                                        setUnvailabilities(response.availabilities);
                                    }
                                case 4:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function checkProductVariantStock() {
                        return _ref.apply(this, arguments);
                    };
                }();
                checkProductVariantStock();
            } else {
                setAvailybilityChecker(false);
                setHasInStock(inStock);
            }
        }
    };
    var changeQuantity = function(quantity) {
        var inStock = (0,utils/* checkStockQuantity */.LY)(stock, products === null || products === void 0 ? void 0 : products.variants[code1]);
        if (quantity <= inStock) {
            setQuantity(quantity);
            trackEvent({
                category: 'Products',
                action: "Quantity changed",
                name: "product ".concat(products.name),
                value: quantity
            });
        }
    };
    //For now the stock alert is made only for sub stores
    var showStockAlert = constants/* isSubscription */.Nn && hasInStock === 0;
    var showSizeAxisLabel = (0,productVariantDisplay/* productVariantsHaveAnyDisplayableSize */.BS)(variants);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sizes ".concat(classes.sizes),
                    children: [
                        showSizeAxisLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: 'div',
                            className: "size__label ".concat(classes.sizes__label),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: settings === null || settings === void 0 ? void 0 : (ref3 = settings.data) === null || ref3 === void 0 ? void 0 : ref3.sizes,
                                    defaultText: t('texts:general:sizes')
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            component: 'div',
                            className: "sizes__stock",
                            children: [
                                code1 !== '' && hasInStock === 0 && (settings === null || settings === void 0 ? void 0 : (ref4 = settings.data) === null || ref4 === void 0 ? void 0 : ref4.back_soon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: settings === null || settings === void 0 ? void 0 : (ref5 = settings.data) === null || ref5 === void 0 ? void 0 : ref5.back_soon,
                                    defaultText: t('texts:general:stock_texts:back_soon')
                                }),
                                code1 !== '' && hasInStock > 0 && hasInStock < 6 && (settings === null || settings === void 0 ? void 0 : (ref6 = settings.data) === null || ref6 === void 0 ? void 0 : ref6.few_products_left) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: settings === null || settings === void 0 ? void 0 : (ref7 = settings.data) === null || ref7 === void 0 ? void 0 : ref7.few_products_left,
                                    defaultText: t('texts:general:stock_texts:few_products_left')
                                }),
                                code1 !== '' && hasInStock > 5 && (settings === null || settings === void 0 ? void 0 : (ref8 = settings.data) === null || ref8 === void 0 ? void 0 : ref8.in_stock) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: settings === null || settings === void 0 ? void 0 : (ref9 = settings.data) === null || ref9 === void 0 ? void 0 : ref9.in_stock,
                                    defaultText: t('texts:general:stock_texts:in_stock')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sizes__list ".concat(classes.sizes__list),
                    children: variants && (variants === null || variants === void 0 ? void 0 : variants.map(function(variant, index) {
                        var ref, ref44, ref45;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                            size: "small",
                            className: variant.code === code1 ? "sizes__btn selected ".concat(classes.selected) : "sizes__btn ".concat(classes.sizeButton),
                            onClick: function() {
                                return handleChange(variant.code, variant.size, variant.tryingOnRequired, variant.tryingOnPrice);
                            },
                            "data-testid": "btn-size-".concat(index),
                            children: [
                                (0,productVariantDisplay/* getVariantChoiceLabel */.nA)(variant),
                                cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
                                    return el.product.variants[0].code === variant.code;
                                }) !== 'undefined' && ((ref = cart.item.items.find(function(el) {
                                    return el.product.variants[0].code === variant.code;
                                })) === null || ref === void 0 ? void 0 : ref.quantity) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: variant.code === code1 ? "sizes__chip ".concat(classes.quantityChip) : "sizes__chip selected ".concat(classes.quantityChip, " ").concat(classes.quantityChipSelected),
                                    children: cart && ((ref44 = cart.item) === null || ref44 === void 0 ? void 0 : ref44.items.length) > 0 && typeof cart.item.items.find(function(el) {
                                        return el.product.variants[0].code === variant.code;
                                    }) !== 'undefined' && ((ref45 = cart.item.items.find(function(el) {
                                        return el.product.variants[0].code === variant.code;
                                    })) === null || ref45 === void 0 ? void 0 : ref45.quantity)
                                })
                            ]
                        }, index));
                    }))
                }),
                availybilityChecker && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.availabilityChecker,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_AvailabilityChecker, {
                        t: t,
                        texts: text === null || text === void 0 ? void 0 : text.data,
                        cart: cart,
                        unvailabilities: unvailabilities,
                        endLeasingDate: parameters.items.maximumLeasingDays
                    })
                }),
                showStockAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockAlert/* default */.Z, {
                    singleProductPrismicData: text,
                    products: focusedProduct,
                    url: currentFullUrl,
                    warehouseId: warehouseId
                }),
                !isSki ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !hasTryOut && hasInStock !== 0 && ((settings === null || settings === void 0 ? void 0 : (ref10 = settings.data) === null || ref10 === void 0 ? void 0 : ref10.has_quantity_selector) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)('sizes-add', classes.button),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)('sizes-add__container', classes.addButton),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)('sizes-add__qtySelector', classes.quantSelector),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                            value: quantity1 !== 0 ? quantity1 : 1,
                                            disable: code1 === '',
                                            handleChange: changeQuantity,
                                            min: 1,
                                            max: maxItemsInCart,
                                            loading: cart.loading,
                                            variantSku: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Size_MainTooltip, {
                                        placement: 'top',
                                        open: showTooltipRent && code1 === '',
                                        title: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : (ref11 = text.data) === null || ref11 === void 0 ? void 0 : ref11.choose_button_tooltip, t('texts:single_product:choose_button_tooltip')),
                                        arrow: true,
                                        enterDelay: 2000,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onMouseEnter: function() {
                                                return setShowTooltipRent(true);
                                            },
                                            onMouseLeave: function() {
                                                return setShowTooltipRent(false);
                                            },
                                            className: classes.fullWidth,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                variant: "contained",
                                                color: "secondary",
                                                disabled: code1 === '' || cart.loading,
                                                "data-testid": 'btn-addToCart',
                                                id: "btn-addToCart",
                                                className: "sizes-add__btn",
                                                onClick: function() {
                                                    return onQuantityChange(code1, name1, quantity1 !== 0 ? quantity1 : 1, false);
                                                },
                                                children: variants[0].purchase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: text === null || text === void 0 ? void 0 : (ref12 = text.data) === null || ref12 === void 0 ? void 0 : ref12.buy_button,
                                                    defaultText: t('texts:single_product:buy_button')
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: text === null || text === void 0 ? void 0 : (ref13 = text.data) === null || ref13 === void 0 ? void 0 : ref13.choose_button,
                                                    defaultText: t('texts:single_product:choose_button')
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "contained",
                            color: "secondary",
                            disabled: code1 === '' || cart.loading || hasInStock === 0,
                            "data-testid": 'btn-addToCart',
                            id: "btn-addToCart",
                            className: "sizes-add__btn",
                            onClick: function() {
                                return onQuantityChange(code1, name1, quantity1 !== 0 ? quantity1 : 1, false);
                            },
                            children: variants[0].purchase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : (ref14 = text.data) === null || ref14 === void 0 ? void 0 : ref14.buy_button,
                                defaultText: t('texts:single_product:buy_button')
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : (ref15 = text.data) === null || ref15 === void 0 ? void 0 : ref15.choose_button,
                                defaultText: t('texts:single_product:choose_button')
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboveProductDescriptionText/* default */.Z, {
                            productSettings: text,
                            className: classes.aboveProductDescriptionText
                        })
                    ]
                }) : code1 !== '' && hasInStock !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_ProductSkiForm, {
                    skiText: skiText,
                    product: products,
                    variantCode: code1
                }),
                hasTryOut && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)('tryout', classes.tryOut),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Size_MainTooltip, {
                            placement: 'top',
                            open: showTooltipRent && code1 === '',
                            title: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : (ref16 = text.data) === null || ref16 === void 0 ? void 0 : ref16.choose_button_tooltip, t('texts:single_product:choose_button_tooltip')),
                            arrow: true,
                            enterDelay: 2000,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onMouseEnter: function() {
                                    return setShowTooltipRent(true);
                                },
                                onMouseLeave: function() {
                                    return setShowTooltipRent(false);
                                },
                                className: classes.fullWidth,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    fullWidth: true,
                                    variant: "contained",
                                    color: "secondary",
                                    disabled: code1 === '' || maxItemsInCart === quantity1 || hasInStock === 0,
                                    onClick: function() {
                                        onQuantityChange(code1, name1, quantity1 + 1, false);
                                        setShowTooltipRent(false);
                                    },
                                    "data-testid": 'btn-addToCart',
                                    id: "btn-addToCart",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: text === null || text === void 0 ? void 0 : (ref17 = text.data) === null || ref17 === void 0 ? void 0 : ref17.choose_button,
                                        defaultText: t('texts:single_product:choose_button')
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Size_MainTooltip, {
                            placement: 'bottom',
                            //PopperProps={{ disablePortal: true }}
                            open: showTooltip && (code1 === '' || (cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.items) === null || ref19 === void 0 ? void 0 : ref19.length) === 0 || !isTryOutAble),
                            title: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : (ref20 = text.data) === null || ref20 === void 0 ? void 0 : ref20.try_out_tooltip, t('texts:single_product:try_out_tooltip')),
                            arrow: true,
                            enterDelay: 2000,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onMouseEnter: function() {
                                    return setShowTooltip(true);
                                },
                                onMouseLeave: function() {
                                    return setShowTooltip(false);
                                },
                                className: classes.fullWidth,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                    fullWidth: true,
                                    variant: "outlined",
                                    className: (0,clsx_m/* default */.Z)('tryout__btn', classes.tryOutButton),
                                    //color="secondary"
                                    disabled: code1 === '' || (cart === null || cart === void 0 ? void 0 : (ref21 = cart.item) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.items) === null || ref22 === void 0 ? void 0 : ref22.length) === 0 || !isTryOutAble || typeof cart.item.items.find(function(item) {
                                        return item.product.variants[0].code === code1;
                                    }) !== 'undefined' || hasInStock === 0,
                                    onClick: function() {
                                        onQuantityChange(code1, name1, quantity1 + 1, true);
                                        setShowTooltip(false);
                                        trackEvent({
                                            category: 'Products',
                                            action: "User add ".concat(name1, " for tryout")
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: text === null || text === void 0 ? void 0 : (ref23 = text.data) === null || ref23 === void 0 ? void 0 : ref23.try_out_button,
                                            defaultText: t('texts:single_product:try_out_button')
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                            amount: tryOnPrice,
                                            showDayOrMonth: false,
                                            dayOrMonth: settings === null || settings === void 0 ? void 0 : (ref24 = settings.data) === null || ref24 === void 0 ? void 0 : ref24.day_or_month,
                                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : (ref25 = settings.data) === null || ref25 === void 0 ? void 0 : ref25.day_or_month_short,
                                            displayFlexPrice: settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Sizes_Size = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Size));

;// CONCATENATED MODULE: ./components/Products/Selectors.tsx










var Selectors_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        selectors: {
            display: 'flex',
            justifyContent: 'flex-start'
        },
        availybilityCheckerRow: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            gap: theme.spacing(1)
        },
        aboveProductDescriptionText: {
            marginTop: theme.spacing(1)
        }
    });
});
var Selectors = function(param) {
    var cart = param.cart, currentItem = param.currentItem, openModal = param.openModal, productSettings = param.productSettings, stock = param.stock, t = param.t, setOpenModal = param.setOpenModal, addProductWithSize = param.addProductWithSize, main = param.main, hasQtySelector = param.hasQtySelector, availybilityChecker = param.availabilityChecker, availability = param.availability, unvailabilities = param.unavailability, parameters = param.parameters, quantity = param.quantity, onQuantityChange = param.onQuantityChange, isBuyableProduct = param.isBuyableProduct, isSki = param.isSki, skiText = param.skiText;
    var ref, ref1, ref2, ref3;
    var productClasses = Selectors_useStyles();
    var currentVariant = currentItem.variants[Object.keys(currentItem.variants)[0]];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: productClasses.selectors,
        children: Object.keys(currentItem.variants).length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: cart && cart.item && cart.item.items && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes_Size, {
                open: openModal,
                text: productSettings,
                stock: stock,
                t: t,
                handleClose: function() {
                    return setOpenModal(false);
                },
                products: currentItem,
                cart: cart,
                skiText: skiText,
                isSki: isSki,
                onQuantityChange: addProductWithSize,
                settings: main
            })
        }) : hasQtySelector ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)(availybilityChecker && !availability && productClasses.availybilityCheckerRow),
            children: availybilityChecker && !availability ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_AvailabilityChecker, {
                t: t,
                cart: cart,
                texts: productSettings === null || productSettings === void 0 ? void 0 : productSettings.data,
                unvailabilities: unvailabilities,
                endLeasingDate: parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.maximumLeasingDays
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                small: false,
                align: "left",
                value: quantity,
                handleChange: onQuantityChange,
                loading: cart.loading,
                min: 0,
                max: currentVariant.maxStock ? currentVariant.maxStock : null,
                variantSku: currentVariant.sku
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(availybilityChecker && !availability && productClasses.availybilityCheckerRow),
            children: [
                availybilityChecker && !availability && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_AvailabilityChecker, {
                    t: t,
                    cart: cart,
                    texts: productSettings === null || productSettings === void 0 ? void 0 : productSettings.data,
                    unvailabilities: unvailabilities,
                    endLeasingDate: parameters === null || parameters === void 0 ? void 0 : (ref1 = parameters.items) === null || ref1 === void 0 ? void 0 : ref1.maximumLeasingDays
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    className: "product__btn-addtocart",
                    variant: "contained",
                    color: "primary",
                    disabled: !availability,
                    onClick: function() {
                        return onQuantityChange(quantity + 1);
                    },
                    children: !isBuyableProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: productSettings === null || productSettings === void 0 ? void 0 : (ref2 = productSettings.data) === null || ref2 === void 0 ? void 0 : ref2.choose_button,
                        defaultText: t('texts:single_product:choose_button')
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: productSettings === null || productSettings === void 0 ? void 0 : (ref3 = productSettings.data) === null || ref3 === void 0 ? void 0 : ref3.buy_button,
                        defaultText: t('texts:single_product:buy_button')
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboveProductDescriptionText/* default */.Z, {
                    productSettings: productSettings,
                    className: productClasses.aboveProductDescriptionText
                })
            ]
        })
    }));
};
/* harmony default export */ var Products_Selectors = (Selectors);

// EXTERNAL MODULE: ./components/Products/ProductTitle.tsx + 1 modules
var ProductTitle = __webpack_require__(48833);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(21737);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./utils/evaluateCondition.ts
var evaluateCondition = __webpack_require__(4676);
;// CONCATENATED MODULE: ./components/Products/ProductDynamicAlert.tsx







var ALERT_COLORS = [
    'success',
    'info',
    'warning',
    'error'
];
var resolveSeverity = function(value) {
    if (!value) return 'info';
    var lowerCased = value.toLowerCase();
    return ALERT_COLORS.includes(lowerCased) ? lowerCased : 'info';
};
var resolveAlertIcon = function(icon) {
    var label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'alert-icon';
    if (!icon) return undefined;
    if (typeof icon === 'string') return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: icon
    }));
    if (icon === null || icon === void 0 ? void 0 : icon.url) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
        src: icon.url,
        alt: icon.alt || label
    }));
    return undefined;
};
var ProductDynamicAlert = function(param) {
    var text = param.text, color = param.color, icon = param.icon, condition = param.condition, data = param.data;
    if (!(text === null || text === void 0 ? void 0 : text.length)) return null;
    var severity = resolveSeverity(color);
    var shouldDisplay = (0,evaluateCondition/* evaluateCondition */.m)(condition, {
        data: data || {}
    });
    if (!shouldDisplay) return null;
    var alertIcon = resolveAlertIcon(icon, (0,CMSText/* prismicText */.yz)(text));
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 2,
        className: "product-dynamic-alert",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            severity: severity,
            icon: alertIcon,
            className: "product-dynamic-alert__content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                data: text
            })
        })
    }));
};
/* harmony default export */ var Products_ProductDynamicAlert = (ProductDynamicAlert);

// EXTERNAL MODULE: ./redux/actions/takeBack.ts + 1 modules
var takeBack = __webpack_require__(42738);
// EXTERNAL MODULE: ./utils/takeBack.tsx + 2 modules
var utils_takeBack = __webpack_require__(71323);
// EXTERNAL MODULE: ./utils/cart.tsx
var utils_cart = __webpack_require__(89910);
// EXTERNAL MODULE: ./components/Products/NoMixedBasketModal.tsx
var NoMixedBasketModal = __webpack_require__(16372);
// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
;// CONCATENATED MODULE: ./interfaces/common/prismicTakeBack.ts
var SecondHandDescriptionPosition;
(function(SecondHandDescriptionPosition) {
    SecondHandDescriptionPosition["BelowProductDescription"] = 'below_product_description';
    SecondHandDescriptionPosition["BelowQualitySelector"] = 'below_quality_selector';
})(SecondHandDescriptionPosition || (SecondHandDescriptionPosition = {}));

// EXTERNAL MODULE: ./components/Products/Product.styles.ts
var Product_styles = __webpack_require__(30327);
// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
// EXTERNAL MODULE: ./utils/takeBackFiltersConditions.tsx
var takeBackFiltersConditions = __webpack_require__(61429);
// EXTERNAL MODULE: ./utils/filters.tsx
var filters = __webpack_require__(92412);
// EXTERNAL MODULE: ./utils/gtag.ts
var gtag = __webpack_require__(65809);
// EXTERNAL MODULE: ./redux/actions/taxons.ts
var taxons = __webpack_require__(44279);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/HrefLangLinks.tsx
var HrefLangLinks = __webpack_require__(39998);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/Favorite.js


/* harmony default export */ var Favorite = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
}), 'Favorite'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/FavoriteBorder.js


/* harmony default export */ var FavoriteBorder = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
}), 'FavoriteBorder'));
// EXTERNAL MODULE: ./redux/actions/wishList.ts + 1 modules
var wishList = __webpack_require__(94624);
;// CONCATENATED MODULE: ./components/Global/CMSTextOrImage.tsx



var isPrismicImage = function(field) {
    return field.type === 'image';
};
var CMSTextOrImage = function(param) {
    var data = param.data;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data.map(function(label, index) {
            if (isPrismicImage(label)) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: label.url,
                    alt: label.alt
                }, index));
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                data: [
                    label
                ]
            }, index));
        })
    }));
};
/* harmony default export */ var Global_CMSTextOrImage = (CMSTextOrImage);

// EXTERNAL MODULE: ./utils/taxPricing.ts
var taxPricing = __webpack_require__(59973);
// EXTERNAL MODULE: ./redux/actions/reservations.ts + 1 modules
var reservations = __webpack_require__(92324);
// EXTERNAL MODULE: ./components/Reservations/ReservationConfirmModal.tsx
var ReservationConfirmModal = __webpack_require__(8717);
// EXTERNAL MODULE: ./components/Products/LoginToSeePriceRow.tsx
var LoginToSeePriceRow = __webpack_require__(3977);
;// CONCATENATED MODULE: ./utils/productImagesStorage.ts
var PRODUCT_IMAGES_STORAGE_KEY = 'product-images-by-code';
var getSavedProductImages = function(productCode) {
    if (!productCode || "object" === 'undefined') return [];
    try {
        var rawStoredImages = window.localStorage.getItem(PRODUCT_IMAGES_STORAGE_KEY);
        var imagesByProductCode = rawStoredImages ? JSON.parse(rawStoredImages) : {};
        var savedImages = imagesByProductCode === null || imagesByProductCode === void 0 ? void 0 : imagesByProductCode[productCode];
        return Array.isArray(savedImages) ? savedImages : [];
    } catch (error) {
        console.warn('[product] Failed to read saved product images from localStorage', error);
        return [];
    }
};
var saveProductImages = function(productCode, images) {
    if (!productCode || "object" === 'undefined' || !Array.isArray(images) || images.length === 0) return;
    try {
        var rawStoredImages = window.localStorage.getItem(PRODUCT_IMAGES_STORAGE_KEY);
        var imagesByProductCode = rawStoredImages ? JSON.parse(rawStoredImages) : {};
        imagesByProductCode[productCode] = images;
        window.localStorage.setItem(PRODUCT_IMAGES_STORAGE_KEY, JSON.stringify(imagesByProductCode));
    } catch (error) {
        console.warn('[product] Failed to save product images in localStorage', error);
    }
};

;// CONCATENATED MODULE: ./pages/products/[product].tsx
/* provided dependency */ var _product_process = __webpack_require__(34155);




























































function _product_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _product_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _product_arrayLikeToArray(arr);
}
function _product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _product_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                _product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                _product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _product_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _product_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _product_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _product_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _product_toConsumableArray(arr) {
    return _product_arrayWithoutHoles(arr) || _product_iterableToArray(arr) || _product_unsupportedIterableToArray(arr) || _product_nonIterableSpread();
}
function _product_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _product_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _product_arrayLikeToArray(o, minLen);
}
var THUMBS_BY_SLIDES = 4;
var formatBreadCrumbTaxonName = function(taxonName) {
    if (true) {
        return taxonName;
    }
    return taxonName.charAt(0).toUpperCase() + taxonName.toLowerCase().slice(1);
};
var Produit = function(param1) {
    var main = param1.main, funnel = param1.funnel, product = param1.product, inStoreText = param1.inStoreText, promotions = param1.promotions, productSettings = param1.productSettings, stock = param1.stock, getProductsBySlug1 = param1.getProductsBySlug, getTakeBackStock1 = param1.getTakeBackStock, parameters = param1.parameters, getProductVariantAvailability1 = param1.getProductVariantAvailability, getTaxons1 = param1.getTaxons, taxons = param1.taxons, takeback = param1.takeback, basket = param1.basket, skiText = param1.skiText, takeBackLP = param1.takeBackLP, stores = param1.stores, accountRes = param1.accountRes, faqRes = param1.faqRes, banner = param1.banner, shop = param1.shop, pageData = param1.pageData, products = param1.products, addToWishList1 = param1.addToWishList, removeFromWishList1 = param1.removeFromWishList, getTaxonsSizes1 = param1.getTaxonsSizes, userIsLoggedIn = param1.userIsLoggedIn, enableBraSizeGuide = param1.enableBraSizeGuide;
    var ref90, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51;
    var ref52 = (0,useCart/* useCart */.j)(), addProductToCart = ref52.addProductToCart, changeProductQuantityInCart = ref52.changeProductQuantityInCart, removeProductFromCart = ref52.removeProductFromCart;
    var classes = (0,Shop_style/* default */.Z)({});
    var productClasses = (0,Product_styles/* useProductStyles */.p)();
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var slug = router.query;
    var cart = (0,es/* useSelector */.v9)(function(state) {
        return state.cart;
    });
    var ref53 = (0,react.useState)(0), quantity1 = ref53[0], setQuantity = ref53[1];
    var ref54 = (0,react.useState)(false), openModal = ref54[0], setOpenModal = ref54[1];
    var ref55 = (0,react.useState)(false), availability = ref55[0], setAvailability = ref55[1];
    var ref56 = (0,react.useState)(false), takeBackAvailability = ref56[0], setTakeBackAvailability = ref56[1];
    var ref57 = (0,react.useState)(false), openInStoreModal = ref57[0], setOpenInStoreModal = ref57[1];
    var ref58 = (0,react.useState)(0), minPrice = ref58[0], setMinPrice = ref58[1];
    var ref59 = (0,react.useState)(0), originalPrice = ref59[0], setOriginalPrice = ref59[1];
    var ref60 = (0,react.useState)(0), takeBackPrice = ref60[0], setTakeBackPrice = ref60[1];
    var ref61 = (0,react.useState)(0), takeBackPriceMinTtc = ref61[0], setTakeBackPriceMinTtc = ref61[1];
    var ref62 = (0,react.useState)(0), takeBackPriceMin = ref62[0], setTakeBackPriceMin = ref62[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref63 = (0,useMatomo/* default */.Z)(), trackEvent = ref63.trackEvent, pushInstruction = ref63.pushInstruction, trackPageView = ref63.trackPageView;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var showRelatedProducts = productSettings === null || productSettings === void 0 ? void 0 : productSettings.data.display_associations;
    var relatedProductsTitle = productSettings === null || productSettings === void 0 ? void 0 : productSettings.data.association_text;
    var addToCartButtonOnAssociatedItem = productSettings === null || productSettings === void 0 ? void 0 : (ref90 = productSettings.data) === null || ref90 === void 0 ? void 0 : ref90.display_add_to_cart_button_on_associated_item;
    var productLayout = productSettings === null || productSettings === void 0 ? void 0 : (ref1 = productSettings.data) === null || ref1 === void 0 ? void 0 : ref1.product_layout;
    var displayHero = productSettings === null || productSettings === void 0 ? void 0 : (ref2 = productSettings.data) === null || ref2 === void 0 ? void 0 : ref2.display_hero_section;
    var hasQtySelector = main === null || main === void 0 ? void 0 : (ref3 = main.data) === null || ref3 === void 0 ? void 0 : ref3.has_quantity_selector;
    var addFromPack = main === null || main === void 0 ? void 0 : (ref4 = main.data) === null || ref4 === void 0 ? void 0 : ref4.only_add_with_pack;
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(main === null || main === void 0 ? void 0 : (ref5 = main.data) === null || ref5 === void 0 ? void 0 : ref5.thumbnail_ratio);
    var thumbWidth = main === null || main === void 0 ? void 0 : (ref6 = main.data) === null || ref6 === void 0 ? void 0 : ref6.small_image_size;
    var cardWidth = main === null || main === void 0 ? void 0 : (ref7 = main.data) === null || ref7 === void 0 ? void 0 : ref7.medium_image_size;
    var largeImgWidth = main === null || main === void 0 ? void 0 : (ref8 = main.data) === null || ref8 === void 0 ? void 0 : ref8.large_image_size;
    var gridItemWidth = (0,utils/* columnLayout */.Zd)(main === null || main === void 0 ? void 0 : (ref9 = main.data) === null || ref9 === void 0 ? void 0 : ref9.page_shop_desktop_columns);
    var isFiveColumns = gridItemWidth === '20%';
    var ref64 = (0,utils/* columnGridLayout */.YF)(productSettings === null || productSettings === void 0 ? void 0 : (ref10 = productSettings.data) === null || ref10 === void 0 ? void 0 : ref10.column_layout), columnLeft = ref64.columnLeft, columnRight = ref64.columnRight;
    var ref65 = (0,react.useState)(true), fromApp = ref65[0], setFromApp = ref65[1];
    var ref66 = (0,react.useState)(product === null || product === void 0 ? void 0 : product.item), currentItem = ref66[0], setCurrentItem = ref66[1];
    var associations = currentItem && currentItem.associations;
    var ref67 = (0,react.useState)(false), isBuyableProduct = ref67[0], setIsBuyableProduct = ref67[1];
    var carouselMain = (0,react.useRef)(null);
    var carouselThumbs = (0,react.useRef)(null);
    var ref68 = (0,react.useState)(0), currentThumb = ref68[0], setCurrentThumb = ref68[1];
    var discountPriceFormat = main === null || main === void 0 ? void 0 : (ref11 = main.data) === null || ref11 === void 0 ? void 0 : ref11.discounted_price_display_format;
    var displayFlexPrice = main === null || main === void 0 ? void 0 : (ref12 = main.data) === null || ref12 === void 0 ? void 0 : ref12.display_flex_price_a_day;
    var isDisplayTotalRentPrice = productSettings === null || productSettings === void 0 ? void 0 : (ref13 = productSettings.data) === null || ref13 === void 0 ? void 0 : ref13.display_total_rental_price;
    var currentPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.currentPromotion;
    var isAvailabilityChecker = productSettings === null || productSettings === void 0 ? void 0 : (ref14 = productSettings.data) === null || ref14 === void 0 ? void 0 : ref14.availability_checker;
    var likingEnabled = (main === null || main === void 0 ? void 0 : (ref15 = main.data) === null || ref15 === void 0 ? void 0 : ref15.wishlist_enabled) && userIsLoggedIn;
    var addToCartBtnOpts = (0,utils/* btnOptions */.gY)(productSettings === null || productSettings === void 0 ? void 0 : (ref16 = productSettings.data) === null || ref16 === void 0 ? void 0 : ref16.add_to_cart_button);
    var ref69 = (0,react.useState)(false), availabilityChecker = ref69[0], setAvailabilityChecker = ref69[1];
    var ref70 = (0,react.useState)([]), unavailability = ref70[0], setUnavailability = ref70[1];
    var ref71 = (0,react.useState)(0), selectedTakeBackOrRental = ref71[0], setSelectedTakeBackOrRental = ref71[1];
    var rentOnly = !takeBackAvailability && availability;
    var secondHandOnly = takeBackAvailability && !availability;
    var ref72 = (0,react.useState)(''), selectedQuality = ref72[0], setSelectedQuality = ref72[1];
    var ref73 = (0,react.useState)(null), selectedQualityObject = ref73[0], setSelectedQualityObject = ref73[1];
    var ref74 = (0,react.useState)(true), showQualities = ref74[0], setShowQualities = ref74[1];
    var ref75 = (0,react.useState)([]), currentSizeQualities = ref75[0], setCurrentSizeQualities = ref75[1];
    var ref76 = (0,react.useState)(''), currentVariantCode = ref76[0], setCurrentVariantCode = ref76[1];
    var ref77 = (0,react.useState)(false), noMoreStockAvailable = ref77[0], setNoMoreStockAvailable = ref77[1];
    var ref78 = (0,react.useState)(''), currentSku = ref78[0], setCurrentSku = ref78[1];
    var ref79 = (0,react.useState)(!(parameters === null || parameters === void 0 ? void 0 : (ref17 = parameters.items) === null || ref17 === void 0 ? void 0 : ref17.enableTakeBack) ? true : false), gliderReady = ref79[0], setGliderReady = ref79[1];
    var ref80 = (0,react.useState)([]), remainSecondHandSkusAfterCheckCart = ref80[0], setRemainSecondHandSkusAfterCheckCart = ref80[1];
    var states = productCheckState(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    var isSecondHand = parameters === null || parameters === void 0 ? void 0 : (ref18 = parameters.items) === null || ref18 === void 0 ? void 0 : ref18.enableTakeBack;
    var ref81 = (0,react.useState)(''), currentSecondHandDescription = ref81[0], setCurrentSecondHandDescription = ref81[1];
    var ref82 = (0,react.useState)(null), typeInCart = ref82[0], setTypeInCart = ref82[1];
    var ref83 = (0,react.useState)(false), fireViewItemGAEvent = ref83[0], setFireViewItemGAEvent = ref83[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref84 = (0,react.useState)(false), reserveModalOpen = ref84[0], setReserveModalOpen = ref84[1];
    var ref85 = (0,react.useState)(false), reserveError = ref85[0], setReserveError = ref85[1];
    var ref86;
    var reservationCreating = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref86 = (ref = state.reservations) === null || ref === void 0 ? void 0 : ref.creating) !== null && ref86 !== void 0 ? ref86 : false;
    });
    var takeBackStockMap = takeBackLP === null || takeBackLP === void 0 ? void 0 : takeBackLP.takeBackStockMap;
    var firstAvailablePuid = (0,react.useMemo)(function() {
        var ref, ref91;
        if (!(main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.enable_reservation) || !takeBackStockMap || !(currentItem === null || currentItem === void 0 ? void 0 : currentItem.variants)) return null;
        var skus = (ref91 = Object.values(currentItem.variants)) === null || ref91 === void 0 ? void 0 : ref91.map(function(v) {
            return v === null || v === void 0 ? void 0 : v.sku;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = skus[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sku = _step.value;
                var ref92;
                var entry = takeBackStockMap.get(sku);
                if (entry === null || entry === void 0 ? void 0 : (ref92 = entry.productsByQuality) === null || ref92 === void 0 ? void 0 : ref92.length) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = entry.productsByQuality[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var q = _step1.value;
                            var ref93;
                            if ((ref93 = q.products) === null || ref93 === void 0 ? void 0 : ref93.length) return q.products[0].puid;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    }, [
        currentItem === null || currentItem === void 0 ? void 0 : currentItem.variants,
        takeBackStockMap
    ]);
    var reservationDays = (main === null || main === void 0 ? void 0 : (ref19 = main.data) === null || ref19 === void 0 ? void 0 : ref19.number_of_reservation_days) || 5;
    var handleReserveConfirm = (0,react.useCallback)(function() {
        if (!firstAvailablePuid) return;
        setReserveError(false);
        var locale = router.locale;
        var prismicLocale = "".concat(locale, "-").concat(locale);
        dispatch((0,reservations/* createReservation */.Rr)(firstAvailablePuid, prismicLocale)).then(function() {
            setReserveModalOpen(false);
            setProductAlreadyReserved(true);
        }).catch(function(error) {
            var ref;
            setReserveError((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) || true);
        });
    }, [
        dispatch,
        firstAvailablePuid,
        router.locale
    ]);
    var baseUrl =  true && window.location.origin ? window.location.origin : '';
    var selectedStoreWarehouseId = stores === null || stores === void 0 ? void 0 : (ref20 = stores.selectedStore) === null || ref20 === void 0 ? void 0 : ref20.warehouseId;
    var _CUSTOM_WAREHOUSE;
    var customWarehouseId = (_CUSTOM_WAREHOUSE = _product_process.env.CUSTOM_WAREHOUSE) !== null && _CUSTOM_WAREHOUSE !== void 0 ? _CUSTOM_WAREHOUSE : null;
    var warehouseId = selectedStoreWarehouseId !== null && selectedStoreWarehouseId !== void 0 ? selectedStoreWarehouseId : customWarehouseId;
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref21 = parameters.items) === null || ref21 === void 0 ? void 0 : ref21.enableChooseStartingDate;
    var currentFullUrl = baseUrl + router.asPath;
    var secondHandStock = (0,react.useMemo)(function() {
        var ref;
        return stock === null || stock === void 0 ? void 0 : (ref = stock.stock) === null || ref === void 0 ? void 0 : ref.filter(function(skuStock) {
            return !!(skuStock === null || skuStock === void 0 ? void 0 : skuStock.secondHand);
        });
    }, [
        stock === null || stock === void 0 ? void 0 : stock.stock
    ]);
    // Keep a ref always pointing to the latest secondHandStock so async
    // callbacks (e.g. getSkuAndTBPStock) don't close over a stale empty array
    // when stock.stock is populated after the effect first fires.
    var secondHandStockRef = (0,react.useRef)(secondHandStock);
    (0,react.useEffect)(function() {
        secondHandStockRef.current = secondHandStock;
    }, [
        secondHandStock
    ]);
    var isSki = product === null || product === void 0 ? void 0 : (ref22 = product.item) === null || ref22 === void 0 ? void 0 : ref22.ski// TODO change this with Sylius value
    ;
    var ref87 = (0,react.useState)([]), currentItemAndAssociationTBStock = ref87[0], setCurrentItemAndAssociationTBStock = ref87[1];
    var showBreadCrumb = (main === null || main === void 0 ? void 0 : (ref23 = main.data) === null || ref23 === void 0 ? void 0 : ref23.show_breadcrumb_product_page) === true;
    var isLiked = products.likedProductsSet.has((ref24 = product.item) === null || ref24 === void 0 ? void 0 : ref24.id);
    var ref88 = (0,react.useMemo)(function() {
        var ref, ref94, ref95;
        if (!taxons.length || !(taxons === null || taxons === void 0 ? void 0 : (ref = taxons[0]) === null || ref === void 0 ? void 0 : (ref94 = ref.children) === null || ref94 === void 0 ? void 0 : ref94.length) || !product.item) return [];
        var _breadCrumbItems = [
            {
                name: t('texts:general:home'),
                href: '/'
            }, 
        ];
        var taxonsMap = new Map(taxons[0].children.map(function(taxon) {
            return [
                taxon.code,
                taxon
            ];
        }));
        var mainTaxons = product.item.taxons.others.map(function(code) {
            return taxonsMap.get(code);
        }).filter(function(taxon) {
            return taxon;
        });
        var categoryTaxon = mainTaxons === null || mainTaxons === void 0 ? void 0 : mainTaxons[0];
        var firstIsMainCategory = (categoryTaxon === null || categoryTaxon === void 0 ? void 0 : (ref95 = categoryTaxon.children) === null || ref95 === void 0 ? void 0 : ref95.length) === 0;
        if (categoryTaxon) {
            var categoryHref = "/".concat(categoryTaxon.slug);
            var name = formatBreadCrumbTaxonName(categoryTaxon.name);
            _breadCrumbItems.push({
                name: name,
                href: categoryHref
            });
            var subCategoryTaxon = firstIsMainCategory ? mainTaxons === null || mainTaxons === void 0 ? void 0 : mainTaxons[1] : categoryTaxon.children.find(function(taxon) {
                return product.item.taxons.others.includes(taxon.code);
            });
            if (subCategoryTaxon) {
                var name1 = formatBreadCrumbTaxonName(subCategoryTaxon.name);
                _breadCrumbItems.push({
                    name: name1,
                    href: "".concat(!firstIsMainCategory ? categoryHref : '', "/").concat(subCategoryTaxon.slug)
                });
            }
        }
        return [
            _breadCrumbItems,
            categoryTaxon
        ];
    }, [
        taxons,
        product
    ]), breadCrumbItems = ref88[0], mainTaxon = ref88[1];
    var isNewButRepairedTaxon = (mainTaxon === null || mainTaxon === void 0 ? void 0 : mainTaxon.slug) === constants/* NEW_BUT_REPAIRED_TAXON_SLUG */.Q0;
    var hrefLangs = (0,react.useMemo)(function() {
        var ref;
        var hrefLanguages = main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.href_languages;
        if (hrefLanguages) {
            var text = (0,CMSText/* prismicText */.yz)(hrefLanguages);
            return text ? text.split(',') : [];
        }
        return [];
    }, [
        main
    ]);
    var ref89 = (0,react.useState)(false), productAlreadyReserved = ref89[0], setProductAlreadyReserved = ref89[1];
    (0,react.useEffect)(function() {
        var ref, ref96, ref97, ref98, ref99;
        if (!(product === null || product === void 0 ? void 0 : product.item)) return;
        var productVariantsSkus = (ref96 = Object.values(product === null || product === void 0 ? void 0 : (ref = product.item) === null || ref === void 0 ? void 0 : ref.variants)) === null || ref96 === void 0 ? void 0 : ref96.map(function(variant) {
            return variant.sku;
        });
        var reservedInStock = (ref98 = stock === null || stock === void 0 ? void 0 : (ref97 = stock.stockMap) === null || ref97 === void 0 ? void 0 : ref97.get(productVariantsSkus[0])) === null || ref98 === void 0 ? void 0 : (ref99 = ref98.secondHand) === null || ref99 === void 0 ? void 0 : ref99.filter(function(secondHand) {
            return secondHand.reservedCount > 0;
        });
        if ((reservedInStock === null || reservedInStock === void 0 ? void 0 : reservedInStock.length) > 0) {
            setProductAlreadyReserved(true);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.item,
        stock === null || stock === void 0 ? void 0 : stock.stockMap
    ]);
    var handleLikeToggle = function() {
        var _product = product.item;
        if (isLiked && _product) {
            removeFromWishList1(_product);
        } else {
            addToWishList1(_product);
        }
    };
    (0,react.useEffect)(function() {
        var ref;
        setCurrentItem(undefined);
        setQuantity(0);
        setAvailability(false);
        setTakeBackAvailability(false);
        setMinPrice(0);
        setOriginalPrice(0);
        setTakeBackPrice(0);
        setTakeBackPriceMinTtc(0);
        setTakeBackPriceMin(0);
        setSelectedTakeBackOrRental(0);
        setSelectedQuality('');
        setSelectedQualityObject(null);
        setShowQualities(true);
        setCurrentSizeQualities([]);
        setCurrentVariantCode('');
        setCurrentSku('');
        setCurrentSecondHandDescription('');
        setTypeInCart(null);
        setFireViewItemGAEvent(false);
        setNoMoreStockAvailable(false);
        setRemainSecondHandSkusAfterCheckCart([]);
        setProductAlreadyReserved(false);
        setCurrentItemAndAssociationTBStock([]);
        setCurrentThumb(0);
        setAvailabilityChecker(false);
        setUnavailability([]);
        setIsBuyableProduct(false);
        setGliderReady(!(parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.enableTakeBack) ? true : false);
        trackPageView({
            documentTitle: "".concat(slug)
        });
        getTaxons1();
        getProductsBySlug1(slug.product);
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
    }, [
        slug.product
    ]);
    // Clear the fetched product from the store when leaving the product page so
    // a previously viewed product can never be used to seed the next visit
    // (e.g. navigating from "my reservations" to a product detail page).
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,actions_products/* resetSingleProduct */.jP)());
        };
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (mainTaxon) {
            getTaxonsSizes1(mainTaxon.slug);
        }
    }, [
        mainTaxon
    ]);
    (0,react.useEffect)(function() {
        if ((product === null || product === void 0 ? void 0 : product.item) && (cart === null || cart === void 0 ? void 0 : cart.item) && _product_process.env.NEXT_PUBLIC_GA_ID && !fireViewItemGAEvent && (constants/* isSecondHandOnly */.G7 && takeBackPrice || !constants/* isSecondHandOnly */.G7)) {
            setFireViewItemGAEvent(true);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.item,
        cart === null || cart === void 0 ? void 0 : cart.item,
        takeBackPrice
    ]);
    (0,react.useEffect)(function() {
        if (fireViewItemGAEvent) {
            var price = 0;
            var quantity = 1;
            var variant = Object.values(product.item.variants)[0];
            if (constants/* isSecondHandOnly */.G7) {
                price = (0,utils/* numberToPrice */.e8)(takeBackPrice);
            } else if (constants/* isDateToDate */.Tr) {
                var _item = cart.item, startLeasingDate = _item.startLeasingDate, endLeasingDate = _item.endLeasingDate;
                var numberOfDays = dayjs_min_default()(endLeasingDate, 'DD/MM/YYYY').diff(dayjs_min_default()(startLeasingDate, 'DD/MM/YYYY'), 'day') + 1;
                var priceByDay = variant.price.current;
                price = (0,utils/* numberToPrice */.e8)(priceByDay * numberOfDays);
            }
            var firstVariant = Object.values(product.item.variants)[0];
            var _obj;
            var gaParams = {
                currency: cart.item.currency,
                value: price * quantity,
                items: [
                    (_obj = {}, _product_defineProperty(_obj, 'item_name', product.item.name), _product_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant.sku : product.item.code), _product_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && firstVariant.code), _product_defineProperty(_obj, "price", price), _product_defineProperty(_obj, "quantity", 1), _obj), 
                ]
            };
            var cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
            (0,gtag/* tracker */.ap)(base/* GAEvent.VIEW_ITEM */.gB.VIEW_ITEM, cleanGAParams);
            (0,gtag/* safeDataLayerPush */.Kx)((0,gtag/* getViewItemGtmData */.hO)(quantity, product, firstVariant));
        }
    }, [
        fireViewItemGAEvent
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            funnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
            basket: basket === null || basket === void 0 ? void 0 : basket.data,
            prismicProduct: productSettings === null || productSettings === void 0 ? void 0 : productSettings.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        funnel,
        main,
        basket,
        productSettings,
        inStoreText
    ]);
    var commonInfo = (0,react.useMemo)(function() {
        var ref, ref100, ref101, ref102, ref103, ref104, ref105;
        return {
            datas: (pageData === null || pageData === void 0 ? void 0 : (ref = pageData.data) === null || ref === void 0 ? void 0 : ref.common_informations) || (main === null || main === void 0 ? void 0 : (ref100 = main.data) === null || ref100 === void 0 ? void 0 : ref100.common_informations),
            layout: (pageData === null || pageData === void 0 ? void 0 : (ref101 = pageData.data) === null || ref101 === void 0 ? void 0 : ref101.common_informations_layout) || (main === null || main === void 0 ? void 0 : (ref102 = main.data) === null || ref102 === void 0 ? void 0 : ref102.common_informations_layout),
            additionalContent: (pageData === null || pageData === void 0 ? void 0 : (ref103 = pageData.data) === null || ref103 === void 0 ? void 0 : ref103.informations_additional_content) || (main === null || main === void 0 ? void 0 : (ref104 = main.data) === null || ref104 === void 0 ? void 0 : ref104.informations_additional_content),
            shippingCosts: productSettings === null || productSettings === void 0 ? void 0 : (ref105 = productSettings.data) === null || ref105 === void 0 ? void 0 : ref105.shipping_costs
        };
    }, [
        main === null || main === void 0 ? void 0 : main.data,
        pageData === null || pageData === void 0 ? void 0 : pageData.data,
        productSettings === null || productSettings === void 0 ? void 0 : productSettings.data
    ]);
    (0,react.useEffect)(function() {
        if (typeof (product === null || product === void 0 ? void 0 : product.item) !== 'undefined') {
            if (selectedTakeBackOrRental === 1) {
                setGliderReady(false);
                var getSkuAndTBPStock = function() {
                    var _ref = _product_asyncToGenerator(runtime_default().mark(function _callee() {
                        var SKUArray, takeBackStockPreLoaded, data, productToChangeForPreSelection, currentProductSkus, secondHandStockForThisProduct;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return (0,utils/* getSkus */.ES)(product === null || product === void 0 ? void 0 : product.item);
                                case 2:
                                    SKUArray = _ctx.sent;
                                    ;
                                    if (!(SKUArray.length > 0)) {
                                        _ctx.next = 10;
                                        break;
                                    }
                                    data = {
                                        lizeeSKUs: SKUArray
                                    };
                                    _ctx.next = 8;
                                    return getTakeBackStock1(data);
                                case 8:
                                    takeBackStockPreLoaded = _ctx.sent;
                                    setCurrentItemAndAssociationTBStock(takeBackStockPreLoaded === null || takeBackStockPreLoaded === void 0 ? void 0 : takeBackStockPreLoaded.response);
                                case 10:
                                    productToChangeForPreSelection = _objectSpread({}, product === null || product === void 0 ? void 0 : product.item);
                                    currentProductSkus = Object.values(productToChangeForPreSelection.variants).map(function(variant) {
                                        return variant.sku;
                                    });
                                    secondHandStockForThisProduct = secondHandStockRef.current.filter(function(skuStock) {
                                        return currentProductSkus.includes(skuStock.lizeeSKU);
                                    });
                                    (0,utils_takeBack/* handlePreselectedSizeAndCondition */.Fk)(secondHandStockForThisProduct, productToChangeForPreSelection, takeBackStockPreLoaded === null || takeBackStockPreLoaded === void 0 ? void 0 : takeBackStockPreLoaded.response, states, cart, setOriginalPrice, setCurrentVariantCode, setCurrentSizeQualities, setShowQualities, setSelectedQuality, setSelectedQualityObject, setCurrentSku, setCurrentItem, setCurrentSecondHandDescription, setTakeBackPrice, setGliderReady, setNoMoreStockAvailable, setRemainSecondHandSkusAfterCheckCart, router);
                                case 14:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function getSkuAndTBPStock() {
                        return _ref.apply(this, arguments);
                    };
                }();
                getSkuAndTBPStock();
            } else {
                var ref111, ref106, ref107, ref108, ref109, ref110;
                setCurrentItem(product.item);
                setGliderReady(true);
                setQuantity(cart && (cart === null || cart === void 0 ? void 0 : cart.item) && (cart === null || cart === void 0 ? void 0 : (ref111 = cart.item) === null || ref111 === void 0 ? void 0 : (ref106 = ref111.items) === null || ref106 === void 0 ? void 0 : ref106.length) > 0 && typeof (cart === null || cart === void 0 ? void 0 : (ref107 = cart.item) === null || ref107 === void 0 ? void 0 : (ref108 = ref107.items) === null || ref108 === void 0 ? void 0 : ref108.find(function(el) {
                    var ref;
                    return el.product.code === (product === null || product === void 0 ? void 0 : (ref = product.item) === null || ref === void 0 ? void 0 : ref.code);
                })) !== 'undefined' ? (ref110 = (ref109 = cart.item.items) === null || ref109 === void 0 ? void 0 : ref109.find(function(el) {
                    var ref;
                    return el.product.code === (product === null || product === void 0 ? void 0 : (ref = product.item) === null || ref === void 0 ? void 0 : ref.code);
                })) === null || ref110 === void 0 ? void 0 : ref110.quantity : 0);
            }
            if (currentItem) {
                var currentTypeInCart = (0,utils_cart/* getCurrentProductTypeInCart */._y)(currentItem, cart);
                setTypeInCart(currentTypeInCart);
            }
        }
    }, [
        product === null || product === void 0 ? void 0 : product.item,
        selectedTakeBackOrRental,
        cart === null || cart === void 0 ? void 0 : (ref25 = cart.item) === null || ref25 === void 0 ? void 0 : ref25.items
    ]);
    (0,react.useEffect)(function() {
        if (typeof (product === null || product === void 0 ? void 0 : product.item) !== 'undefined') {
            if (selectedTakeBackOrRental === 1) {
                var productToChangeAfterAddedItemInCart = _objectSpread({}, product === null || product === void 0 ? void 0 : product.item);
                var currentProductSkus = Object.values(productToChangeAfterAddedItemInCart.variants).map(function(variant) {
                    return variant.sku;
                });
                var secondHandStockForThisProduct = secondHandStock.filter(function(skuStock) {
                    return currentProductSkus.includes(skuStock.lizeeSKU);
                });
                setGliderReady(false);
                (0,utils_takeBack/* handlePreselectedSizeAndCondition */.Fk)(secondHandStockForThisProduct, productToChangeAfterAddedItemInCart, takeBackLP === null || takeBackLP === void 0 ? void 0 : takeBackLP.takeBackStock, states, cart, setOriginalPrice, setCurrentVariantCode, setCurrentSizeQualities, setShowQualities, setSelectedQuality, setSelectedQualityObject, setCurrentSku, setCurrentItem, setCurrentSecondHandDescription, setTakeBackPrice, setGliderReady, setNoMoreStockAvailable, setRemainSecondHandSkusAfterCheckCart, router);
            }
            if (currentItem) {
                var currentTypeInCart = (0,utils_cart/* getCurrentProductTypeInCart */._y)(currentItem, cart);
                setTypeInCart(currentTypeInCart);
            }
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref26 = cart.item) === null || ref26 === void 0 ? void 0 : ref26.items,
        secondHandStock
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (constants/* store */.h !== 'lunettes-de-zac' || "object" === 'undefined' || !(product === null || product === void 0 ? void 0 : (ref = product.item) === null || ref === void 0 ? void 0 : ref.code)) return;
        var productVariantKeys = Object.keys(product.item.variants);
        var productVariantSku = product.item.variants[productVariantKeys[0]].sku;
        var savedImages = getSavedProductImages(product.item.code);
        if (!(savedImages === null || savedImages === void 0 ? void 0 : savedImages.length)) {
            var ref114, ref115, ref116;
            // get images from stock
            savedImages = (ref115 = (ref114 = stock.stockMap) === null || ref114 === void 0 ? void 0 : ref114.get(productVariantSku)) === null || ref115 === void 0 ? void 0 : (ref116 = ref115.secondHand) === null || ref116 === void 0 ? void 0 : ref116.flatMap(function(secondHand) {
                return secondHand.images;
            });
        }
        if ((savedImages === null || savedImages === void 0 ? void 0 : savedImages.length) > 0) {
            setCurrentItem(function(previousItem) {
                return previousItem || (product === null || product === void 0 ? void 0 : product.item) ? _objectSpread({}, previousItem || product.item, {
                    images: savedImages
                }) : previousItem;
            });
        }
    }, [
        product === null || product === void 0 ? void 0 : (ref27 = product.item) === null || ref27 === void 0 ? void 0 : ref27.code,
        product === null || product === void 0 ? void 0 : product.item,
        stock === null || stock === void 0 ? void 0 : stock.stockMap
    ]);
    (0,react.useEffect)(function() {
        var sourceItem = currentItem || (product === null || product === void 0 ? void 0 : product.item);
        if (constants/* store */.h !== 'lunettes-de-zac' || "object" === 'undefined' || !(sourceItem === null || sourceItem === void 0 ? void 0 : sourceItem.code) || !Array.isArray(sourceItem === null || sourceItem === void 0 ? void 0 : sourceItem.images) || sourceItem.images.length === 0) return;
        saveProductImages(sourceItem.code, sourceItem.images);
    }, [
        currentItem === null || currentItem === void 0 ? void 0 : currentItem.code,
        currentItem === null || currentItem === void 0 ? void 0 : currentItem.images,
        product === null || product === void 0 ? void 0 : product.item
    ]);
    (0,react.useEffect)(function() {
        if (selectedQuality) {
            var chosenQualityObject = (0,utils_takeBack/* getChosenQualityObject */.U9)(selectedQuality, currentSizeQualities, currentSku, secondHandStock);
            setSelectedQualityObject(chosenQualityObject);
        } else {
            setSelectedQualityObject(null);
        }
    }, [
        selectedQuality
    ]);
    var handleSizeSelected = function(sku) {
        var ref;
        var qualitiesArray = (0,utils_takeBack/* createProductsQualityArrayBySize */.vO)(takeBackLP === null || takeBackLP === void 0 ? void 0 : takeBackLP.takeBackStock, sku, states, cart);
        var originalPriceFromCurrentItem = (0,utils_takeBack/* handleTakeBackOriginalPrice */.vM)(currentItem, sku);
        setOriginalPrice(originalPriceFromCurrentItem);
        setCurrentVariantCode((ref = Object.values(currentItem.variants)) === null || ref === void 0 ? void 0 : ref.find(function(el) {
            return el.sku === sku;
        }).code);
        setCurrentSizeQualities(qualitiesArray);
        setShowQualities(true);
        setSelectedQuality('');
        setCurrentSku(sku);
        // in order to pre-select one condition when user changes size according filter and available conditions
        var availableConditions = qualitiesArray.filter(function(quality) {
            return !quality.disabled;
        }).map(function(quality) {
            return quality.quality;
        });
        var filteredConditions = (0,takeBackFiltersConditions/* getAvailableFilteredConditions */.DM)(availableConditions);
        var chosenCondition = (0,filters/* getLowestConditionByConditions */.bE)(filteredConditions ? (0,takeBackFiltersConditions/* getAvailableFilteredConditions */.DM)(availableConditions) : availableConditions);
        var preselectedCondition = qualitiesArray.find(function(qualityInfo) {
            return qualityInfo.quality === chosenCondition;
        });
        handleStateSelected(preselectedCondition);
    };
    var handleStateSelected = function(quality) {
        var _images, _images1;
        var ref, ref117, ref118;
        var numberInCart = (0,utils_takeBack/* currentQualityInCart */.bz)(quality.quality, currentSku, cart);
        var secondHandDescription = (quality === null || quality === void 0 ? void 0 : quality.products) !== undefined && ((ref = quality === null || quality === void 0 ? void 0 : quality.products[numberInCart]) === null || ref === void 0 ? void 0 : ref.note);
        var item = _objectSpread({}, product === null || product === void 0 ? void 0 : product.item);
        var images = [];
        (_images = images).push.apply(_images, _product_toConsumableArray((ref117 = quality === null || quality === void 0 ? void 0 : quality.products[numberInCart]) === null || ref117 === void 0 ? void 0 : ref117.images));
        (_images1 = images).push.apply(_images1, _product_toConsumableArray(item.images));
        item.images = images;
        setCurrentItem(item);
        setSelectedQuality(quality === null || quality === void 0 ? void 0 : quality.quality);
        setCurrentSecondHandDescription(secondHandDescription);
        var ref119 = (ref118 = Object.values(currentItem.variants)) === null || ref118 === void 0 ? void 0 : ref118.find(function(el) {
            return el.sku === currentSku;
        }), currentPricesByCondition = ref119.resalePrice, taxIncludedInPrice = ref119.taxIncludedInPrice, taxRate = ref119.taxRate;
        var priceHt = currentPricesByCondition[quality.quality];
        var priceTtc = priceHt;
        var pricingWithTax = (0,taxPricing/* getPricingWithTaxInfo */.B)(priceHt, taxIncludedInPrice, taxRate);
        priceHt = pricingWithTax.priceHt;
        priceTtc = pricingWithTax.priceTtc;
        setTakeBackPrice(priceHt);
        setTakeBackPriceMinTtc(priceTtc);
    };
    var onQuantityChange = function(quantity) {
        var ref, ref120, ref121, ref122, ref123, ref124, ref125, ref126, ref127;
        var productCode = product.item.code;
        var productInCart = cart && cart.item && ((ref = cart.item) === null || ref === void 0 ? void 0 : (ref120 = ref.items) === null || ref120 === void 0 ? void 0 : ref120.length) > 0 && typeof ((ref121 = cart.item.items) === null || ref121 === void 0 ? void 0 : ref121.find(function(el) {
            return el.product.code === productCode;
        })) !== 'undefined' && ((ref122 = cart.item.items) === null || ref122 === void 0 ? void 0 : ref122.find(function(el) {
            return el.product.code === productCode;
        }));
        var firstVariant = Object.keys(product.item.variants)[0] !== '0' ? Object.keys(product.item.variants)[0] : product.item.variants[0].code;
        var productInCartFirstVariant = productInCart && Object.keys(productInCart === null || productInCart === void 0 ? void 0 : (ref123 = productInCart.product) === null || ref123 === void 0 ? void 0 : ref123.variants)[0];
        var response = (0,addToCart/* addToCartUtility */.$)(firstVariant, quantity, cart, parameters, productInCart, false, stock);
        trackEvent({
            category: 'Products',
            action: "Quantity changed",
            name: "product ".concat(product === null || product === void 0 ? void 0 : (ref124 = product.item) === null || ref124 === void 0 ? void 0 : ref124.name),
            value: quantity
        });
        var unitaryPrice = (0,utils/* numberToPrice */.e8)((ref126 = productInCart === null || productInCart === void 0 ? void 0 : (ref125 = productInCart.product) === null || ref125 === void 0 ? void 0 : ref125.variants[productInCartFirstVariant]) === null || ref126 === void 0 ? void 0 : (ref127 = ref126.price) === null || ref127 === void 0 ? void 0 : ref127.current);
        var totalPrice = unitaryPrice * quantity;
        if (availability) {
            switch(response.message){
                case 'limit':
                case 'max':
                case 'add':
                    var ref128;
                    trackEvent({
                        category: 'Add to Cart',
                        action: "".concat(product === null || product === void 0 ? void 0 : (ref128 = product.item) === null || ref128 === void 0 ? void 0 : ref128.name),
                        name: "".concat(router.pathname),
                        value: totalPrice
                    });
                    if (response.productInCart) {
                        var ref129, ref130, ref131, ref132, ref133, ref134, ref135;
                        changeProductQuantityInCart(productInCart.id, {
                            quantity: quantity
                        }, base/* GAEvent.ADD_TO_CART */.gB.ADD_TO_CART, stock);
                        pushInstruction('addEcommerceItem', (ref130 = productInCart === null || productInCart === void 0 ? void 0 : (ref129 = productInCart.product) === null || ref129 === void 0 ? void 0 : ref129.variants[productInCartFirstVariant]) === null || ref130 === void 0 ? void 0 : ref130.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref131 = productInCart.product) === null || ref131 === void 0 ? void 0 : ref131.name, productInCart === null || productInCart === void 0 ? void 0 : (ref132 = productInCart.product) === null || ref132 === void 0 ? void 0 : (ref133 = ref132.taxons) === null || ref133 === void 0 ? void 0 : ref133.main, unitaryPrice, quantity);
                        pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref134 = cart.item) === null || ref134 === void 0 ? void 0 : (ref135 = ref134.totals) === null || ref135 === void 0 ? void 0 : ref135.total));
                    } else {
                        if (product.item.isSimpleProduct) {
                            var ref136, ref137, ref138, ref139, ref140, ref141, ref142, ref143;
                            addProductToCart({
                                productCode: productCode,
                                quantity: quantity
                            });
                            pushInstruction('addEcommerceItem', (ref137 = product === null || product === void 0 ? void 0 : (ref136 = product.item) === null || ref136 === void 0 ? void 0 : ref136.variants[firstVariant]) === null || ref137 === void 0 ? void 0 : ref137.sku, product === null || product === void 0 ? void 0 : (ref138 = product.item) === null || ref138 === void 0 ? void 0 : ref138.name, product === null || product === void 0 ? void 0 : (ref139 = product.item) === null || ref139 === void 0 ? void 0 : (ref140 = ref139.taxons) === null || ref140 === void 0 ? void 0 : ref140.main, (0,utils/* numberToPrice */.e8)((ref142 = product === null || product === void 0 ? void 0 : (ref141 = product.item) === null || ref141 === void 0 ? void 0 : ref141.variants[firstVariant]) === null || ref142 === void 0 ? void 0 : (ref143 = ref142.price) === null || ref143 === void 0 ? void 0 : ref143.current), quantity);
                            pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                        } else {
                            addProductToCart({
                                productCode: productCode,
                                quantity: quantity,
                                variantCode: firstVariant
                            });
                            pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                        }
                    }
                    break;
                case 'remove':
                    var ref144, ref145, ref146, ref147, ref148, ref149;
                    changeProductQuantityInCart(productInCart.id, {
                        quantity: quantity
                    }, base/* GAEvent.REMOVE_FROM_CART */.gB.REMOVE_FROM_CART, stock);
                    trackEvent({
                        category: 'Remove from Cart',
                        action: "".concat(product === null || product === void 0 ? void 0 : (ref144 = product.item) === null || ref144 === void 0 ? void 0 : ref144.name),
                        name: "".concat(router.pathname),
                        value: totalPrice
                    });
                    pushInstruction('addEcommerceItem', (ref146 = productInCart === null || productInCart === void 0 ? void 0 : (ref145 = productInCart.product) === null || ref145 === void 0 ? void 0 : ref145.variants[productInCartFirstVariant]) === null || ref146 === void 0 ? void 0 : ref146.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref147 = productInCart.product) === null || ref147 === void 0 ? void 0 : ref147.name, productInCart === null || productInCart === void 0 ? void 0 : (ref148 = productInCart.product) === null || ref148 === void 0 ? void 0 : (ref149 = ref148.taxons) === null || ref149 === void 0 ? void 0 : ref149.main, unitaryPrice, quantity);
                    pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                    break;
                case 'delete':
                    var ref150, ref151, ref152;
                    trackEvent({
                        category: 'Delete from Cart',
                        action: "".concat(product === null || product === void 0 ? void 0 : (ref150 = product.item) === null || ref150 === void 0 ? void 0 : ref150.name),
                        name: "".concat(router.pathname),
                        value: totalPrice
                    });
                    removeProductFromCart(productInCart);
                    pushInstruction('removeEcommerceItem', (ref152 = productInCart === null || productInCart === void 0 ? void 0 : (ref151 = productInCart.product) === null || ref151 === void 0 ? void 0 : ref151.variants[productInCartFirstVariant]) === null || ref152 === void 0 ? void 0 : ref152.sku);
                    pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                    break;
                default:
                    break;
            }
            setQuantity(quantity);
            setOpenModal(false);
        }
    };
    // add product with a variant
    var addProductWithSize = function(variantCode, variantName, quantity, isTryOut) {
        var ref, ref153, ref154, ref155, ref156, ref157;
        var productInCart = cart && cart.item && ((ref = cart.item.items) === null || ref === void 0 ? void 0 : ref.length) > 0 && typeof ((ref153 = cart.item.items) === null || ref153 === void 0 ? void 0 : ref153.find(function(el) {
            return el.product.variants[0].code === variantCode;
        })) !== 'undefined' && ((ref154 = cart.item.items) === null || ref154 === void 0 ? void 0 : ref154.find(function(el) {
            return el.product.variants[0].code === variantCode;
        }));
        var inStock = 0;
        if (productInCart) {
            inStock = (0,utils/* checkStockQuantity */.LY)(stock, productInCart.product.variants[0]);
        }
        var response = (0,addToCart/* addToCartUtility */.$)(variantName, quantity, cart, parameters, productInCart, isTryOut, inStock);
        var unitaryPrice = (0,utils/* numberToPrice */.e8)((ref156 = productInCart === null || productInCart === void 0 ? void 0 : (ref155 = productInCart.product) === null || ref155 === void 0 ? void 0 : ref155.variants[variantCode]) === null || ref156 === void 0 ? void 0 : (ref157 = ref156.price) === null || ref157 === void 0 ? void 0 : ref157.current);
        var totalPrice = unitaryPrice * quantity;
        if (response.productInCart) {
            var ref158, ref159, ref160, ref161, ref162, ref163;
            changeProductQuantityInCart(productInCart.id, {
                quantity: quantity
            }, base/* GAEvent.ADD_TO_CART */.gB.ADD_TO_CART, inStock);
            trackEvent({
                category: 'Add to Cart',
                action: "".concat(product === null || product === void 0 ? void 0 : (ref158 = product.item) === null || ref158 === void 0 ? void 0 : ref158.name),
                name: "".concat(router.pathname),
                value: totalPrice
            });
            pushInstruction('addEcommerceItem', (ref160 = productInCart === null || productInCart === void 0 ? void 0 : (ref159 = productInCart.product) === null || ref159 === void 0 ? void 0 : ref159.variants[0]) === null || ref160 === void 0 ? void 0 : ref160.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref161 = productInCart.product) === null || ref161 === void 0 ? void 0 : ref161.name, productInCart === null || productInCart === void 0 ? void 0 : (ref162 = productInCart.product) === null || ref162 === void 0 ? void 0 : (ref163 = ref162.taxons) === null || ref163 === void 0 ? void 0 : ref163.main, unitaryPrice, quantity);
            pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
        } else {
            var ref164, ref165, ref166, ref167, ref168, ref169, ref170, ref171;
            pushInstruction('addEcommerceItem', (ref165 = (ref164 = product.item) === null || ref164 === void 0 ? void 0 : ref164.variants[variantCode]) === null || ref165 === void 0 ? void 0 : ref165.sku, (ref166 = product.item) === null || ref166 === void 0 ? void 0 : ref166.name, (ref167 = product.item) === null || ref167 === void 0 ? void 0 : (ref168 = ref167.taxons) === null || ref168 === void 0 ? void 0 : ref168.main, (0,utils/* numberToPrice */.e8)((ref170 = (ref169 = product.item) === null || ref169 === void 0 ? void 0 : ref169.variants[variantCode]) === null || ref170 === void 0 ? void 0 : (ref171 = ref170.price) === null || ref171 === void 0 ? void 0 : ref171.current), quantity);
            pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
            if (response.message === 'add' || response.message === 'limit') {
                var ref172;
                trackEvent({
                    category: 'Add to Cart',
                    action: "".concat(product === null || product === void 0 ? void 0 : (ref172 = product.item) === null || ref172 === void 0 ? void 0 : ref172.name),
                    name: "".concat(router.pathname),
                    value: totalPrice
                });
                addProductToCart({
                    productCode: product.item.code,
                    quantity: quantity,
                    variantCode: variantCode
                });
            } else if (response.message === 'add tryout') {
                var ref173, ref174, ref175, ref176;
                trackEvent({
                    category: 'Add to Cart for tryout',
                    action: "".concat(product === null || product === void 0 ? void 0 : (ref173 = product.item) === null || ref173 === void 0 ? void 0 : ref173.name),
                    name: "".concat(router.pathname),
                    value: (0,utils/* numberToPrice */.e8)(((ref175 = (ref174 = product.item) === null || ref174 === void 0 ? void 0 : ref174.variants[variantCode]) === null || ref175 === void 0 ? void 0 : (ref176 = ref175.price) === null || ref176 === void 0 ? void 0 : ref176.current) * quantity)
                });
                addProductToCart({
                    productCode: product.item.code,
                    quantity: quantity,
                    variantCode: variantCode,
                    withTryingOn: true
                });
            }
        }
        setOpenModal(false);
    };
    (0,react.useEffect)(function() {
        var ref;
        var priceArray = [];
        var originalPriceArray = [];
        var takeBackPriceArray = [];
        var takeBackMinPriceArray = [];
        if (product && typeof (product === null || product === void 0 ? void 0 : product.item) !== 'undefined' && (stock === null || stock === void 0 ? void 0 : stock.stock) && (stock === null || stock === void 0 ? void 0 : (ref = stock.stock) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var _Math, _Math1;
            var ref177;
            // Handle rental availability
            var productAvailability = (0,utils/* checkProductAvailability */.HF)(stock, product === null || product === void 0 ? void 0 : product.item);
            setAvailability(productAvailability.available);
            // Handle second hand availability
            setTakeBackAvailability(productAvailability.secondHandAvailable);
            // Handle Prices
            for(var variantKey in product === null || product === void 0 ? void 0 : (ref177 = product.item) === null || ref177 === void 0 ? void 0 : ref177.variants){
                var ref178, ref179;
                var variant = product === null || product === void 0 ? void 0 : (ref178 = product.item) === null || ref178 === void 0 ? void 0 : ref178.variants[variantKey];
                if (!(variant === null || variant === void 0 ? void 0 : variant.purchase)) {
                    var ref180;
                    priceArray.push(variant === null || variant === void 0 ? void 0 : (ref180 = variant.price) === null || ref180 === void 0 ? void 0 : ref180.current);
                    setIsBuyableProduct(false);
                } else {
                    priceArray.push(variant === null || variant === void 0 ? void 0 : variant.purchasePrice);
                    setIsBuyableProduct(true);
                }
                originalPriceArray.push(variant === null || variant === void 0 ? void 0 : (ref179 = variant.originalPrice) === null || ref179 === void 0 ? void 0 : ref179.current);
            }
            // The price displayed on loading is the lowest price between all the variants
            setMinPrice((_Math = Math).min.apply(_Math, _product_toConsumableArray(priceArray)));
            // Same logic for the original price
            setOriginalPrice((_Math1 = Math).min.apply(_Math1, _product_toConsumableArray(originalPriceArray)));
            // Same logic for second hand prices with takeBackAvailability in mind
            if (productAvailability.secondHandAvailable) {
                var ref181;
                Object.values((ref181 = product.item) === null || ref181 === void 0 ? void 0 : ref181.variants).forEach(function(variant) {
                    if (variant === null || variant === void 0 ? void 0 : variant.resalePrice) {
                        Object.values(variant === null || variant === void 0 ? void 0 : variant.resalePrice).forEach(function(price) {
                            takeBackPriceArray.push(price);
                        });
                    }
                });
            }
            // find lowest 2nd hand price available
            if (productAvailability.secondHandAvailable) {
                takeBackMinPriceArray = (0,utils/* productLowestPrice */.OC)(product === null || product === void 0 ? void 0 : product.item, takeBackLP);
            }
            if (takeBackMinPriceArray.length > 0) {
                // find the element with minimum price on takeBackMinPriceArray
                var foundTakeBackMinPriceObj = takeBackMinPriceArray.reduce(function(prev, curr) {
                    return prev.price < curr.price ? prev : curr;
                }, takeBackMinPriceArray[0]);
                var price1 = foundTakeBackMinPriceObj.price, taxIncludedInPrice = foundTakeBackMinPriceObj.taxIncludedInPrice, taxRate = foundTakeBackMinPriceObj.taxRate;
                var pricingWithTax = (0,taxPricing/* getPricingWithTaxInfo */.B)(price1, taxIncludedInPrice, taxRate);
                setTakeBackPriceMin(pricingWithTax.priceHt);
                setTakeBackPriceMinTtc(pricingWithTax.priceTtc);
            }
        }
    }, [
        product.item,
        stock,
        takeBackLP
    ]);
    (0,react.useEffect)(function() {
        var ref, ref182, ref183;
        // Check availability for product with only one variant
        if (isAvailabilityChecker && !availability && (product === null || product === void 0 ? void 0 : (ref = product.item) === null || ref === void 0 ? void 0 : ref.variants) && ((ref183 = Object.values(product === null || product === void 0 ? void 0 : (ref182 = product.item) === null || ref182 === void 0 ? void 0 : ref182.variants)) === null || ref183 === void 0 ? void 0 : ref183.length) === 1) {
            setAvailabilityChecker(true);
            var checkProductVariantStock = function() {
                var _ref = _product_asyncToGenerator(runtime_default().mark(function _callee() {
                    var response;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return getProductVariantAvailability1(Object.values(product.item.variants)[0].sku);
                            case 2:
                                response = _ctx.sent;
                                if (response.type === 'GET_STOCK_AVAILABILITY_SUCCESS') {
                                    setUnavailability(response.availabilities);
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function checkProductVariantStock() {
                    return _ref.apply(this, arguments);
                };
            }();
            checkProductVariantStock();
        }
    }, [
        product.item
    ]);
    (0,react.useEffect)(function() {
        var ref;
        // Turns out that opening a tab start your history at 1
        if ((window === null || window === void 0 ? void 0 : (ref = window.history) === null || ref === void 0 ? void 0 : ref.length) <= 2) {
            setFromApp(false);
        }
    }, [
        fromApp
    ]);
    (0,react.useEffect)(function() {
        if (rentOnly) {
            setSelectedTakeBackOrRental(0);
            setGliderReady(true);
        }
        if (secondHandOnly) setSelectedTakeBackOrRental(1);
    }, [
        secondHandOnly,
        rentOnly
    ]);
    var handleCloseInStoreModal = function() {
        setOpenInStoreModal(false);
    };
    var handleOpenInStoreModal = function() {
        setOpenInStoreModal(true);
    };
    (0,react.useEffect)(function() {
        if (currentItem === null || currentItem === void 0 ? void 0 : currentItem.images) {
            var ref;
            for(var index = 0; index < Math.ceil((currentItem === null || currentItem === void 0 ? void 0 : (ref = currentItem.images) === null || ref === void 0 ? void 0 : ref.length) / THUMBS_BY_SLIDES); index++){
                if (Math.floor(currentThumb / THUMBS_BY_SLIDES) === index) {
                    var ref184;
                    (ref184 = carouselThumbs.current) === null || ref184 === void 0 ? void 0 : ref184.scrollItem(index, true);
                }
            }
        }
    }, [
        currentThumb,
        currentItem === null || currentItem === void 0 ? void 0 : currentItem.images
    ]);
    var handleCarouselMainNav = function(pos) {
        setCurrentThumb(pos.detail.slide);
    };
    var handleCarouselThumbNav = function(pos) {
        var ref;
        (ref = carouselMain.current) === null || ref === void 0 ? void 0 : ref.scrollItem(pos);
        setCurrentThumb(pos);
    };
    var start = dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref28 = cart.item) === null || ref28 === void 0 ? void 0 : ref28.startLeasingDate, 'DD/MM/YYYY');
    var end = dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref29 = cart.item) === null || ref29 === void 0 ? void 0 : ref29.endLeasingDate, 'DD/MM/YYYY');
    var dayRange = end.diff(start, 'day') + 1;
    var handleTakeBackAndRental = function(event, newValue) {
        setSelectedTakeBackOrRental(newValue);
    };
    var handleChangeCurrentItem = function(newItem) {
        setCurrentItem(_objectSpread({}, newItem));
    };
    var secondHandDescriptionPosition = takeback === null || takeback === void 0 ? void 0 : (ref30 = takeback.data) === null || ref30 === void 0 ? void 0 : ref30.take_back_description_position;
    var ProductDesc = function() {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    component: "div",
                    className: (0,clsx_m/* default */.Z)('product__desc', classes.shopApiContent, productClasses.desc, productLayout && isMobile && productClasses.smallText),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: currentItem.description
                        }
                    })
                }),
                isSecondHand && (currentSecondHandDescription === null || currentSecondHandDescription === void 0 ? void 0 : currentSecondHandDescription.length) > 0 && selectedTakeBackOrRental === 1 && (!secondHandDescriptionPosition || secondHandDescriptionPosition === SecondHandDescriptionPosition.BelowProductDescription) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            component: "div",
                            className: (0,clsx_m/* default */.Z)('product__desc', 'take_back_description'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.take_back_description,
                                defaultText: t('texts:takeBack:take_back_description')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            component: "div",
                            className: (0,clsx_m/* default */.Z)('product__desc'),
                            children: currentSecondHandDescription.length > 0 && currentSecondHandDescription
                        })
                    ]
                })
            ]
        });
    };
    //This part of code is made to identify the short product shown and its unique variant
    //when there are no size choices, it is needed for the stockAlert component
    var currentProduct = product.loading === false ? product.item : undefined;
    var uniSizedProductVariant = currentProduct ? Object.values(currentProduct.variants)[0] : undefined;
    var inStock1 = uniSizedProductVariant ? (0,utils/* checkStockQuantity */.LY)(stock, uniSizedProductVariant) : 0;
    var shortProduct = uniSizedProductVariant ? [
        {
            sku: uniSizedProductVariant.sku,
            quantity: inStock1
        }, 
    ] : undefined;
    //For now the stock alert is made only for sub stores
    var showStockAlert = constants/* isSubscription */.Nn;
    var hasManySizes = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.variants) ? Object.keys(currentItem === null || currentItem === void 0 ? void 0 : currentItem.variants).length > 1 : false;
    var handleBack = function() {
        fromApp ? router.back() : router.push('/shop');
    };
    var ProductAddToCart = function() {
        var ref, ref185, ref186;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                availability && takeBackAvailability && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_TakeBackAndRentTab, {
                    selectedTakeBackOrRental: selectedTakeBackOrRental,
                    handleTakeBackAndRental: handleTakeBackAndRental,
                    takeback: takeback,
                    t: t,
                    typeInCart: typeInCart
                }),
                !addFromPack && (availability || hasManySizes ? currentItem && currentItem.variants && selectedTakeBackOrRental === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_Selectors, {
                    cart: cart,
                    currentItem: currentItem,
                    openModal: openModal,
                    productSettings: productSettings,
                    stock: stock,
                    t: t,
                    setOpenModal: setOpenModal,
                    addProductWithSize: addProductWithSize,
                    main: main,
                    hasQtySelector: hasQtySelector,
                    availabilityChecker: availabilityChecker,
                    availability: availability,
                    unavailability: unavailability,
                    parameters: parameters,
                    quantity: quantity1,
                    onQuantityChange: onQuantityChange,
                    isBuyableProduct: isBuyableProduct,
                    isSki: isSki,
                    skiText: skiText
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: !(parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.in_store) ? (productSettings === null || productSettings === void 0 ? void 0 : (ref185 = productSettings.data) === null || ref185 === void 0 ? void 0 : ref185.availability_checker) && selectedTakeBackOrRental === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_Selectors, {
                        cart: cart,
                        currentItem: currentItem,
                        openModal: openModal,
                        productSettings: productSettings,
                        stock: stock,
                        t: t,
                        setOpenModal: setOpenModal,
                        addProductWithSize: addProductWithSize,
                        main: main,
                        hasQtySelector: hasQtySelector,
                        availabilityChecker: availabilityChecker,
                        availability: availability,
                        unavailability: unavailability,
                        parameters: parameters,
                        quantity: quantity1,
                        onQuantityChange: onQuantityChange,
                        isBuyableProduct: isBuyableProduct,
                        isSki: isSki,
                        skiText: skiText
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            rentOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                className: 'product__unavailable',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: productSettings === null || productSettings === void 0 ? void 0 : (ref186 = productSettings.data) === null || ref186 === void 0 ? void 0 : ref186.sold_out,
                                    defaultText: t('texts:packs:victim_of_success')
                                })
                            }),
                            showStockAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockAlert/* default */.Z, {
                                singleProductPrismicData: productSettings === null || productSettings === void 0 ? void 0 : productSettings.data,
                                products: shortProduct,
                                url: currentFullUrl,
                                warehouseId: warehouseId
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            showStockAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockAlert/* default */.Z, {
                                singleProductPrismicData: productSettings === null || productSettings === void 0 ? void 0 : productSettings.data,
                                products: shortProduct,
                                url: currentFullUrl,
                                warehouseId: warehouseId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InStoreSoldOut/* default */.Z, {
                                datas: inStoreText,
                                layout: productLayout,
                                handleOpenInStoreModal: handleOpenInStoreModal,
                                defaultText: {
                                    title: t('texts:instore:product_not_available'),
                                    desc: t('texts:instore:paragraph'),
                                    cta: t('texts:instore:change_store_cta')
                                }
                            })
                        ]
                    })
                }))
            ]
        }));
    };
    //This part of code has been made to fix the following error
    //"NotFoundError: Failed to execute 'removeChild' on 'Node'"
    //TODO:To avoid the use of this fix, bump react version to 18.x.x
    //and react-i18next version to 12.x.x
    if (typeof Node === 'function' && Node.prototype) {
        var originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function Produit(child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.warn('Cannot remove a child from a different parent', child, this);
                }
                return child;
            }
            // eslint-disable-next-line prefer-rest-params
            return originalRemoveChild.apply(this, arguments);
        };
        var originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.warn('Cannot insert before a reference node from a different parent', referenceNode, this);
                }
                return newNode;
            }
            // eslint-disable-next-line prefer-rest-params
            return originalInsertBefore && originalInsertBefore.apply(this, arguments);
        };
    }
    var secondHandItemCommentNode = secondHandDescriptionPosition === SecondHandDescriptionPosition.BelowQualitySelector && (currentSecondHandDescription === null || currentSecondHandDescription === void 0 ? void 0 : currentSecondHandDescription.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: 2,
        className: 'second_hand_item_comment',
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                component: "div",
                className: (0,clsx_m/* default */.Z)('product__desc', 'take_back_description'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: takeback === null || takeback === void 0 ? void 0 : (ref31 = takeback.data) === null || ref31 === void 0 ? void 0 : ref31.take_back_description,
                    defaultText: t('texts:takeBack:take_back_description')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                component: "div",
                className: (0,clsx_m/* default */.Z)('product__desc'),
                children: currentSecondHandDescription
            })
        ]
    }) : null;
    var TakeBackSizeRender = function(params) {
        if (constants/* hidePricingOnGhostUser */.FB && !userIsLoggedIn) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                sm: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginToSeePriceRow/* default */.Z, {
                    text: accountRes === null || accountRes === void 0 ? void 0 : accountRes.data
                })
            }));
        } else {
            var ref, ref187, ref188, ref189, ref190;
            var _obj;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)(productClasses.selectors, (_obj = {}, _product_defineProperty(_obj, productClasses.reservationEnabled, main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.enable_reservation), _product_defineProperty(_obj, 'product__selectors--reservation', main === null || main === void 0 ? void 0 : (ref187 = main.data) === null || ref187 === void 0 ? void 0 : ref187.enable_reservation), _obj)),
                children: [
                    (main === null || main === void 0 ? void 0 : main.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBackSize/* default */.Z, _objectSpread({
                        t: t,
                        products: currentItem,
                        handleChangeCurrentItem: handleChangeCurrentItem,
                        noMoreStockAvailable: noMoreStockAvailable,
                        cart: cart,
                        addProductToCart: addProductToCart,
                        settings: main.data,
                        takeback: takeback,
                        currentItem: currentItem,
                        selectedQuality: selectedQuality,
                        handleStateSelected: handleStateSelected,
                        handleSizeSelected: handleSizeSelected,
                        showQualities: showQualities,
                        sku: currentSku,
                        currentSizeQualities: currentSizeQualities,
                        currentVariantCode: currentVariantCode,
                        productSettings: productSettings,
                        currentQualityInCart: utils_takeBack/* currentQualityInCart */.bz,
                        setSelectedQuality: setSelectedQuality,
                        availableSkus: remainSecondHandSkusAfterCheckCart,
                        displayBraGuidePanel: enableBraSizeGuide,
                        aboveAddToCartNode: secondHandItemCommentNode
                    }, params)),
                    (main === null || main === void 0 ? void 0 : (ref188 = main.data) === null || ref188 === void 0 ? void 0 : ref188.enable_reservation) && productAlreadyReserved && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                            severity: "info",
                            className: classes.reservationAlert,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/my-reservations",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "data-testid": 'go_to_reservations',
                                    onClick: function() {
                                        return trackEvent({
                                            category: 'user Reservations',
                                            action: "User go to his Reservations"
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: main === null || main === void 0 ? void 0 : (ref189 = main.data) === null || ref189 === void 0 ? void 0 : ref189.reservations_product_already_reserved,
                                        defaultText: t('texts:reservations:reservations_product_already_reserved')
                                    })
                                })
                            })
                        })
                    }),
                    userIsLoggedIn && (main === null || main === void 0 ? void 0 : (ref190 = main.data) === null || ref190 === void 0 ? void 0 : ref190.enable_reservation) && firstAvailablePuid && !productAlreadyReserved && !noMoreStockAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "primary",
                                variant: "outlined",
                                className: "product__reserve-btn",
                                fullWidth: true,
                                onClick: function() {
                                    return setReserveModalOpen(true);
                                },
                                children: t('texts:reservations:reserve_cta', {
                                    days: reservationDays
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationConfirmModal/* default */.Z, {
                                open: reserveModalOpen,
                                onClose: function() {
                                    return setReserveModalOpen(false);
                                },
                                onConfirm: handleReserveConfirm,
                                loading: reservationCreating,
                                reservationDays: reservationDays,
                                error: reserveError
                            })
                        ]
                    })
                ]
            }));
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref32 = main.data) === null || ref32 === void 0 ? void 0 : ref32.logo,
        t: t,
        doc: main,
        inStoreText: inStoreText,
        metaTitle: product === null || product === void 0 ? void 0 : (ref33 = product.item) === null || ref33 === void 0 ? void 0 : ref33.name,
        metaDescriptionProduct: product === null || product === void 0 ? void 0 : (ref34 = product.item) === null || ref34 === void 0 ? void 0 : ref34.metaDescription,
        metaKeywordsProduct: product === null || product === void 0 ? void 0 : (ref35 = product.item) === null || ref35 === void 0 ? void 0 : ref35.metaKeywords,
        basket: basket,
        takeback: takeback,
        account: accountRes,
        faq: faqRes,
        banner: banner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangLinks/* default */.Z, {
                locales: hrefLangs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (0,clsx_m/* default */.Z)(classes.root, 'page--product'),
                children: [
                    !isMobile && !displayHero && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {
                        title: (0,CMSText/* prismicText */.yz)(main === null || main === void 0 ? void 0 : (ref36 = main.data) === null || ref36 === void 0 ? void 0 : ref36.baseline, t('texts:general:baseline')),
                        heroImg: main === null || main === void 0 ? void 0 : (ref37 = main.data) === null || ref37 === void 0 ? void 0 : ref37.hero_banner,
                        heroSettings: main === null || main === void 0 ? void 0 : main.data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (0,clsx_m/* default */.Z)('product__content', classes.shopContent, classes.shopContentSingle),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                maxWidth: "xl",
                                className: (0,clsx_m/* default */.Z)('product__container', classes.shopContainer),
                                children: [
                                    (!isMobile && !displayHero && !constants/* isSecondHandOnly */.G7 && selectedTakeBackOrRental === 0 && !constants/* isSubscription */.Nn || !isMobile && !displayHero && !constants/* isSecondHandOnly */.G7 && constants/* isSubscription */.Nn && isEnableChooseStartingDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)('shop__planner', classes.shopPlanner, classes.shopPlannerDad),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeForm/* default */.Z, {
                                                text: main === null || main === void 0 ? void 0 : main.data,
                                                textFunnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
                                                t: t,
                                                parameters: parameters,
                                                scrollTarget: 'product-single'
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                        maxWidth: "xl",
                                        className: (0,clsx_m/* default */.Z)('product__area', classes.shopArea, classes.shopAreaSingle),
                                        children: [
                                            showBreadCrumb ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, {
                                                separator: "›",
                                                "arial-label": "Breadcrumb",
                                                expandText: "...",
                                                className: "product__breadcrumbs",
                                                children: breadCrumbItems === null || breadCrumbItems === void 0 ? void 0 : breadCrumbItems.map(function(param) {
                                                    var name = param.name, href = param.href;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                            href: href,
                                                            children: name
                                                        })
                                                    }, name);
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                className: (0,clsx_m/* default */.Z)('product__prev', productClasses.prev),
                                                variant: "outlined",
                                                color: "secondary",
                                                onClick: function() {
                                                    return handleBack();
                                                },
                                                size: "small",
                                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: main === null || main === void 0 ? void 0 : (ref38 = main.data) === null || ref38 === void 0 ? void 0 : ref38.previous_button,
                                                    defaultText: t('texts:general:previous_button')
                                                })
                                            }),
                                            product.loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                className: (0,clsx_m/* default */.Z)('product__grid', productClasses.main),
                                                container: true,
                                                spacing: isMobile ? 4 : 8,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, _objectSpread({
                                                        item: true,
                                                        className: "product__left"
                                                    }, columnLeft, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                            className: productClasses.loadingImg,
                                                            variant: 'rect',
                                                            "data-ratio": aspectRatio
                                                        })
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, _objectSpread({
                                                        item: true,
                                                        className: 'product__right'
                                                    }, columnRight, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "h3",
                                                                component: "div",
                                                                className: productClasses.loadingTitle,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    variant: "text"
                                                                })
                                                            }),
                                                            Array.from(new Array(12)).map(function(el, index) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "body1",
                                                                    component: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                        variant: "text",
                                                                        width: "".concat(Math.floor(Math.random() * 100) + 1, "%")
                                                                    })
                                                                }, index + 1));
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                className: productClasses.loadingBtn,
                                                                variant: 'rect',
                                                                width: 200
                                                            })
                                                        ]
                                                    }))
                                                ]
                                            }) : currentItem && typeof currentItem !== 'undefined' && typeof product !== 'undefined' && product.item && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                                in: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    className: (0,clsx_m/* default */.Z)('product__main', productClasses.main, constants/* imageFixInProductDetail */.ae && !isMobile && productClasses.productMainStickyLayout),
                                                    container: true,
                                                    spacing: isMobile ? 4 : 8,
                                                    "data-testid": 'product-loaded',
                                                    id: 'product-single',
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, _objectSpread({
                                                            item: true,
                                                            className: (0,clsx_m/* default */.Z)(productClasses.productLeft, 'product__left', constants/* imageFixInProductDetail */.ae && !isMobile && productClasses.productLeftSticky)
                                                        }, columnLeft, {
                                                            children: [
                                                                likingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                    className: productClasses.likeButton,
                                                                    onClick: handleLikeToggle,
                                                                    "data-testid": "like-button-".concat(((ref39 = product.item) === null || ref39 === void 0 ? void 0 : ref39.code) || ''),
                                                                    children: isLiked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite, {
                                                                        color: "secondary"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder, {})
                                                                }),
                                                                productLayout ? currentItem.images.map(function(image, index) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                        id: "img-".concat(index),
                                                                        "data-ratio": aspectRatio,
                                                                        className: productClasses.mediaGap,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                                            alt: "",
                                                                            imagePaths: image,
                                                                            classes: productClasses.mediaMain,
                                                                            settings: (0,utils/* getProductImageKitSettings */.rI)(largeImgWidth, aspectRatio)
                                                                        })
                                                                    }, "img-".concat(index));
                                                                }) : (currentItem === null || currentItem === void 0 ? void 0 : (ref40 = currentItem.images) === null || ref40 === void 0 ? void 0 : ref40.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        gliderReady && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: productClasses.carouselMain,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                                                hasArrows: true,
                                                                                draggable: true,
                                                                                scrollLock: true,
                                                                                slidesToShow: 1,
                                                                                iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                                                                iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                                ref: carouselMain,
                                                                                onSlideVisible: function(event) {
                                                                                    return handleCarouselMainNav(event);
                                                                                },
                                                                                scrollLockDelay: 100,
                                                                                duration: 1,
                                                                                children: currentItem === null || currentItem === void 0 ? void 0 : (ref41 = currentItem.images) === null || ref41 === void 0 ? void 0 : ref41.map(function(image, index) {
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            "data-ratio": aspectRatio,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                                                                settings: (0,utils/* getProductImageKitSettings */.rI)(largeImgWidth, aspectRatio),
                                                                                                imagePaths: image,
                                                                                                classes: productClasses.mediaMain
                                                                                            })
                                                                                        })
                                                                                    }, index);
                                                                                })
                                                                            }, "".concat(currentItem.name, "-").concat(currentItem === null || currentItem === void 0 ? void 0 : (ref42 = currentItem.images) === null || ref42 === void 0 ? void 0 : ref42.length))
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                            className: (0,clsx_m/* default */.Z)(productClasses.carouselThumbs, productClasses.carouselThumbsSmall),
                                                                            container: true,
                                                                            spacing: 3,
                                                                            children: gliderReady && /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                                                hasArrows: (currentItem === null || currentItem === void 0 ? void 0 : (ref43 = currentItem.images) === null || ref43 === void 0 ? void 0 : ref43.length) > THUMBS_BY_SLIDES && !isMobile ? true : false,
                                                                                scrollLock: true,
                                                                                draggable: true,
                                                                                slidesToShow: THUMBS_BY_SLIDES,
                                                                                ref: carouselThumbs,
                                                                                scrollLockDelay: 100,
                                                                                duration: 1,
                                                                                iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                                                                iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                                children: currentItem === null || currentItem === void 0 ? void 0 : (ref44 = currentItem.images) === null || ref44 === void 0 ? void 0 : ref44.map(function(image, index) {
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                                        p: 1.5,
                                                                                        onClick: function() {
                                                                                            return handleCarouselThumbNav(index);
                                                                                        },
                                                                                        className: (0,clsx_m/* default */.Z)('carousel__thumb', productClasses.carouselThumb, currentThumb === index && productClasses.carouselThumbCurrent, 'carousel__thumb--active'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            "data-ratio": aspectRatio,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                                                                settings: (0,utils/* getProductImageKitSettings */.rI)(thumbWidth, aspectRatio),
                                                                                                imagePaths: image,
                                                                                                classes: productClasses.carouselThumbsImg
                                                                                            })
                                                                                        })
                                                                                    }, index);
                                                                                })
                                                                            }, "".concat(currentItem.name, "-").concat(currentItem === null || currentItem === void 0 ? void 0 : (ref45 = currentItem.images) === null || ref45 === void 0 ? void 0 : ref45.length))
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: productClasses.mediaGap,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        "data-ratio": aspectRatio,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                                            alt: "",
                                                                            imagePaths: currentItem === null || currentItem === void 0 ? void 0 : currentItem.images[0],
                                                                            classes: productClasses.mediaMain,
                                                                            settings: (0,utils/* getProductImageKitSettings */.rI)(largeImgWidth, aspectRatio)
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, _objectSpread({
                                                            item: true,
                                                            className: 'product__right'
                                                        }, columnRight, {
                                                            children: [
                                                                isMobile && productLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDesc, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (0,clsx_m/* default */.Z)(productLayout && !isMobile && !constants/* imageFixInProductDetail */.ae && productClasses.contentSticky),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (0,clsx_m/* default */.Z)(productLayout && isMobile && productClasses.contentSticky),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTitle/* default */.Z, {
                                                                                    productLayout: productLayout,
                                                                                    isMobile: isMobile,
                                                                                    currentItem: currentItem,
                                                                                    addFromPack: addFromPack,
                                                                                    promotions: promotions,
                                                                                    minPrice: minPrice,
                                                                                    takeBackPrice: takeBackPrice,
                                                                                    main: main,
                                                                                    isBuyableProduct: isBuyableProduct,
                                                                                    discountPriceFormat: discountPriceFormat,
                                                                                    selectedTakeBackOrRental: selectedTakeBackOrRental,
                                                                                    takeback: takeback,
                                                                                    displayFlexPrice: displayFlexPrice,
                                                                                    isDisplayTotalRentPrice: isDisplayTotalRentPrice,
                                                                                    productSettings: productSettings,
                                                                                    dayRange: dayRange,
                                                                                    currentPromotion: currentPromotion,
                                                                                    selectedQuality: selectedQuality,
                                                                                    originalPrice: originalPrice,
                                                                                    takeBackPriceMin: takeBackPriceMin,
                                                                                    takeBackPriceMinTtc: takeBackPriceMinTtc,
                                                                                    takeBackAvailability: takeBackAvailability,
                                                                                    isDisplayedPrice: main === null || main === void 0 ? void 0 : (ref46 = main.data) === null || ref46 === void 0 ? void 0 : ref46.is_product_price_displayed,
                                                                                    isSecondHand: isSecondHand,
                                                                                    displayProductState: !isNewButRepairedTaxon,
                                                                                    productTaxons: currentItem === null || currentItem === void 0 ? void 0 : currentItem.taxons
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (0,clsx_m/* default */.Z)('product__details', productClasses.content, productLayout && productClasses.contentDetailsSticky, !availability && 'product__details--unavailable'),
                                                                                    children: [
                                                                                        addToCartBtnOpts === 'Both' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAddToCart, {}),
                                                                                                selectedTakeBackOrRental === 1 && takeBackAvailability && /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBackSizeRender, {})
                                                                                            ]
                                                                                        }),
                                                                                        addToCartBtnOpts === 'Above' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAddToCart, {}),
                                                                                                selectedTakeBackOrRental === 1 && takeBackAvailability && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    className: productClasses.selectors,
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBackSizeRender, {
                                                                                                        secondHandAvailability: takeBackAvailability,
                                                                                                        displayWarrantyText: !isNewButRepairedTaxon
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        currentItem.description && productLayout ? !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDesc, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDesc, {}),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_ProductDynamicAlert, {
                                                                                            text: productSettings === null || productSettings === void 0 ? void 0 : (ref47 = productSettings.data) === null || ref47 === void 0 ? void 0 : ref47.product_alert_text,
                                                                                            color: "warning",
                                                                                            icon: productSettings === null || productSettings === void 0 ? void 0 : (ref48 = productSettings.data) === null || ref48 === void 0 ? void 0 : ref48.product_alert_icon,
                                                                                            condition: productSettings === null || productSettings === void 0 ? void 0 : (ref49 = productSettings.data) === null || ref49 === void 0 ? void 0 : ref49.show_product_alert_condition,
                                                                                            data: product === null || product === void 0 ? void 0 : product.item
                                                                                        }),
                                                                                        addToCartBtnOpts === 'Both' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAddToCart, {}),
                                                                                                selectedTakeBackOrRental === 1 && takeBackAvailability && /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBackSizeRender, {})
                                                                                            ]
                                                                                        }),
                                                                                        addToCartBtnOpts === 'Below' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAddToCart, {}),
                                                                                                selectedTakeBackOrRental === 1 && takeBackAvailability && /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBackSizeRender, {})
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        (commonInfo === null || commonInfo === void 0 ? void 0 : commonInfo.additionalContent) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Global_CMSTextOrImage, {
                                                                            data: commonInfo === null || commonInfo === void 0 ? void 0 : commonInfo.additionalContent
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonInformations/* default */.Z, _objectSpread({}, commonInfo)),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomMenuLinks/* default */.Z, {
                                                                            datas: main === null || main === void 0 ? void 0 : (ref50 = main.data) === null || ref50 === void 0 ? void 0 : ref50.bottom_menu_links
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })),
                                                        currentItem.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            xs: 12,
                                                            className: "product__short-description",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: 'body1',
                                                                component: 'div',
                                                                className: classes.shopApiContent,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: currentItem.shortDescription
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showRelatedProducts && associations && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: 'xl',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)('product-related', productClasses.related),
                                    children: ((ref51 = Object.keys(associations)) === null || ref51 === void 0 ? void 0 : ref51.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'h3',
                                                component: 'h2',
                                                className: (0,clsx_m/* default */.Z)('product-related__title', productClasses.relatedTitle),
                                                children: !product.loading ? (0,CMSText/* prismicText */.yz)(relatedProductsTitle, t('texts:single_product:associations_title')) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    variant: "text",
                                                    width: "28ch"
                                                })
                                            }),
                                            !product.loading ? Object.keys(associations).map(function(association, index1) {
                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    container: true,
                                                    spacing: 3,
                                                    className: productClasses.associationRow,
                                                    children: associations[association].map(function(relatedItem, index) {
                                                        if (relatedItem.enabled) {
                                                            var image = null;
                                                            // if secondHand is enabled, check if the product is available in stock.
                                                            // if it's available in stock, show the image of the product from stock.
                                                            if (isSecondHand) {
                                                                var relatedItemSkus = Object.values(relatedItem === null || relatedItem === void 0 ? void 0 : relatedItem.variants).map(function(relatedItemVariant) {
                                                                    return relatedItemVariant.sku;
                                                                });
                                                                image = (0,utils_takeBack/* getSecondHandImageForRelatedProduct */.sd)(relatedItemSkus, currentItemAndAssociationTBStock);
                                                            }
                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                item: true,
                                                                xs: 6,
                                                                lg: isFiveColumns ? 2 : gridItemWidth,
                                                                className: isFiveColumns ? productClasses.md5 : productClasses.col,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                                                    isRelated: true,
                                                                    settings: main === null || main === void 0 ? void 0 : main.data,
                                                                    stock: stock,
                                                                    text: productSettings,
                                                                    productCode: relatedItem.code,
                                                                    slug: relatedItem.slug,
                                                                    name: relatedItem.name,
                                                                    thumb: image !== null && image !== void 0 ? image : relatedItem === null || relatedItem === void 0 ? void 0 : relatedItem.images,
                                                                    thumbRatio: aspectRatio,
                                                                    thumbWidth: cardWidth,
                                                                    product: relatedItem,
                                                                    addButton: addToCartButtonOnAssociatedItem,
                                                                    promotions: promotions,
                                                                    shopData: shop,
                                                                    isReleatedProduct: true
                                                                })
                                                            }, index));
                                                        }
                                                    })
                                                }, index1));
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                container: true,
                                                spacing: 3,
                                                className: productClasses.associationRow,
                                                children: Array.from(new Array(5)).map(function(el, index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 6,
                                                        lg: isFiveColumns ? 2 : gridItemWidth,
                                                        className: isFiveColumns ? productClasses.md5 : productClasses.col,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    "data-ratio": aspectRatio,
                                                                    variant: "rect"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    variant: "text",
                                                                    width: "16ch"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    variant: "text",
                                                                    width: "5ch"
                                                                })
                                                            ]
                                                        })
                                                    }, index));
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeStoreModal/* default */.Z, {
                                handleClose: handleCloseInStoreModal,
                                open: openInStoreModal,
                                doc: inStoreText,
                                t: t
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMixedBasketModal/* default */.Z, {
                                basket: basket
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var _product_mapStateToProps = function(state) {
    return {
        cart: state.cart,
        product: state.product,
        products: state.products,
        /**
   * @todo In the component stock is expected to be a number, but it's in fact an object, find out why?!
   */ stock: state.stock,
        stores: state.stores,
        parameters: state.parameters,
        promotions: state.promotions,
        takeBackLP: state.takeBack,
        taxons: state.taxons.items,
        userIsLoggedIn: state.user.isLoggedIn
    };
};
var _product_mapDispatchToProps = {
    getProductsBySlug: actions_products/* getProductsBySlug */.cs,
    getProductVariantAvailability: actions_products/* getProductVariantAvailability */.eI,
    getTakeBackStock: takeBack/* getTakeBackStock */.Rl,
    dispatchSaveFetchedProduct: actions_products/* saveFetchedProduct */.Yw,
    getTaxons: taxons/* getTaxons */.xI,
    getTaxonsSizes: taxons/* getTaxonsSizes */.JG,
    addToWishList: wishList/* addToWishList */.s3,
    removeFromWishList: wishList/* removeFromWishList */.AW
};
var __N_SSG = true;
/* harmony default export */ var _product_ = ((0,es/* connect */.$j)(_product_mapStateToProps, _product_mapDispatchToProps)(Produit));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,76142,75436,84997,50273,20355,230,19789,29705,79956,17012,18496,4998,44405,49774,92888,40179], function() { return __webpack_exec__(91325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);